import { initializeApp } from "https://www.gstatic.com/firebasejs/9.17.2/firebase-app.js";
import {
  getDatabase,
  get,
  child,
  ref,
  set,
  update,
} from "https://www.gstatic.com/firebasejs/9.17.2/firebase-database.js";
import {
  getStorage,
  ref as sRef,
  uploadString,
  getDownloadURL,
} from "https://www.gstatic.com/firebasejs/9.17.2/firebase-storage.js";

const firebaseConfig = {
  apiKey: "AIzaSyDI_8uG-DpLCQAykIoHkDEEVcdBEh3Ord8",
  authDomain: "tenth-house.firebaseapp.com",
  projectId: "tenth-house",
  storageBucket: "tenth-house.appspot.com",
  messagingSenderId: "488894593799",
  appId: "1:488894593799:web:773442babdb9bd9ee6e3a2",
};

const app = initializeApp(firebaseConfig);
const database = getDatabase(app);
const storage = getStorage();

const finishCartElements = document.getElementsByClassName("toOrder");
if (finishCartElements != null) {
  // console.log(finishCartElements)
}

/*document.getElementById('takeImageM').addEventListener('click', event => {
  FixUpColors('resultsToShow_M');
  TakeScreenShot();
});

document.getElementById('takeImage').addEventListener('click', event => {
  FixUpColors('resultsToShow_D');
  TakeScreenShot();
});*/
if (finishCartElements[0] != null) {
  finishCartElements[0].addEventListener("click", (event) => {
    finishCartElements[0].disabled = true;
    finishCartElements[0].textContent = "Please Wait...";
    console.log("pressed button");
    FinishQuiz();
  });
}
if (finishCartElements[1] != null) {
  finishCartElements[1].addEventListener("click", (event) => {
    finishCartElements[1].disabled = true;
    finishCartElements[1].textContent = "Please Wait...";
    console.log("pressed button");
    FinishQuiz();
  });
}

function FinishQuiz() {
  event.preventDefault();
  alert("take screenshot");
  // TakeScreenShot();
  SaveUsersDataInMemory();
}

var shareImage = document.getElementById("shareImage");

shareImage.addEventListener("click", (event) => {
  alert("shareImage clicked-");
  var imgData;
  var imgDatafull;
  if (
    document.getElementsByClassName("desktop__version")[0].style.display ==
    "none"
  ) {
    // MOBILE VERSION
    const element = document.getElementById("braceletParent_Mobile");
    html2canvas(element).then((canvas) => {
      imgData = canvas.toDataURL();
      shareImageData(imgData);
    });

    // // ------------full quiz image
    // const elementfull = document.getElementById('resultsPage_M');
    // html2canvas(elementfull).then((canvas) => {
    //   imgDatafull = canvas.toDataURL();
    //   shareImageData(imgDatafull);
    // });
  } else {
    // DESKTOP VERSION
    const element = document.getElementById("resultsPage");
    html2canvas(element).then((canvas) => {
      imgData = canvas.toDataURL();
      shareImageData(imgData);
    });
  }
});

var shareImage2 = document.getElementById("shareImage2");

shareImage2.addEventListener("click", (event) => {
  alert("shareImage2 clicked-");
  var imgData;
  if (
    document.getElementsByClassName("desktop__version")[0].style.display ==
    "none"
  ) {
    // MOBILE VERSION
    const element = document.getElementById("braceletParent_Mobile");
    html2canvas(element).then((canvas) => {
      imgData = canvas.toDataURL();
      shareImageData(imgData);
    });
    //  // ------------full quiz image
    // const elementfull = document.getElementById('resultsPage_M');
    // html2canvas(elementfull).then((canvas) => {
    //   imgDatafull = canvas.toDataURL();
    //   shareImageData(imgDatafull);
    // });
  } else {
    // DESKTOP VERSION
    const element = document.getElementById("resultsPage");
    html2canvas(element).then((canvas) => {
      imgData = canvas.toDataURL();
      shareImageData(imgData);
    });
  }
});

function shareImageData(imgData) {
  fetch(imgData)
    .then((res) => res.blob())
    .then((blob) => {
      const file = new File([blob], "screenshot.png", { type: "image/png" });
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        navigator
          .share({
            files: [file],
            title: "Tenth House Shop",
            url: "https://www.shoptenthhouse.com/pages/necklace_generator",
            text: "Get Your Necklace Chart Done! ",
          })
          .then(() => console.log("Successful share", imgData))
          .catch((error) => console.log("Error sharing", error));
      }
    });
}

var saveImageButton = document.getElementById("downloadImage");

saveImageButton.addEventListener("click", (event) => {
  event.preventDefault();
  SaveImageLocaly();
});

var saveImageButtonM = document.getElementById("downloadImageM");

saveImageButtonM.addEventListener("click", (event) => {
  event.preventDefault();
  SaveImageLocaly();
});

function FixUpColors(idToUse) {
  var parent = document.getElementById(idToUse);
  const spans = parent.querySelectorAll("[marker='marker']");
  spans.forEach((span) => {
    const className = span.className;
    const parts = className.split(" ");
    parts[1] = "image";
    const newClassName = parts.join(" ");
    span.className = newClassName;
  });
}

var savedImage;
var savedEmail;
var savedNotes;

var savedImagefull;
var savedEmailfull;

var firebaseEmailParent;

var newID;
var productName;

function TakeScreenShot() {
  console.log("screenshot!");

  // document.getElementById('MainContent').style.overflow = 'scroll';
  document.getElementById("MainContent").style.height = "100%";
  var tempHeight =
    document.getElementsByClassName("desktop__version")[0].style.height;
  // console.log(tempHeight,'tempHeight---');
  document.getElementsByClassName("desktop__version")[0].style.height = "100%";

  if (document.getElementById("modelViewD").style.display == "block") {
    //TURN OFF 3D VIEW
    var desktopNecklace2D = document.getElementById("braceletParent_Desktop");
    var mobileNecklace2D = document.getElementById("braceletParent_Mobile");

    var desktopNecklace3D = document.getElementById("modelViewD");
    var mobileNecklace3D = document.getElementById("modelViewM");

    var modelButtonMobile = document.getElementById("ModelButton_M");
    var modelButtonDekstop = document.getElementById("ModelButton_D");

    desktopNecklace2D.style.display = "";
    mobileNecklace2D.style.display = "";

    desktopNecklace3D.style.display = "table-column";
    mobileNecklace3D.style.display = "table-column";

    modelButtonMobile.style.backgroundImage =
      "url('{{ '3D.png' | asset_url }}')";
    modelButtonDekstop.style.backgroundImage =
      "url('{{ '3D.png' | asset_url }}')";
  }

  var mobileTutorial = document.getElementById("mobileTutorial");
  var desktopTutorial = document.getElementById("desktopTutorial");

  if (mobileTutorial != null) {
    if (mobileTutorial.style.display == "block") {
      mobileTutorial.style.display = "none";
    }
  }
  if (desktopTutorial != null) {
    if (desktopTutorial.style.display == "block") {
      desktopTutorial.style.display = "none";
    }
  }

  if (
    document.getElementsByClassName("desktop__version")[0].style.display ==
    "none"
  ) {
    //MOBILE VERSION

    // const element = document.getElementById("braceletParent_Mobile");
    // alert('image stored');
    // ------------crop quiz image
    // const elementfull = document.getElementById('resultsPage_M');
    // ---------------------------
    var emailAddress = document.getElementById("email_M").value;
    const elementfull = document.getElementById("braceletParent_Mobile");
    // console.log(elementfull,"elementfull",typeof elementfull);
    html2canvas(elementfull).then((canvas) => {
      const imgDatafull = canvas.toDataURL();
      savedImagefull = imgDatafull;
      savedEmailfull = emailAddress;
      console.log(
        "crop img--------------------------------------------------id"
      );
      SendDataToServer();
      // alert('complte crop')
    });

    const element = document.getElementById("result_full");
    // console.log(element,"element",typeof element);
    html2canvas(element).then((canvas) => {
      const imgData = canvas.toDataURL();
      savedImage = imgData;
      savedEmail = emailAddress;
      SendDataToServer();
      console.log(
        "full img--------------------------------------------------id"
      );
      // alert('complte full')
    });
  } else {
    //DESKTOP VERSION
    const element = document.getElementById("MainContent");
    var emailAddress = document.getElementById("email_D").value;

    html2canvas(element).then((canvas) => {
      const imgData = canvas.toDataURL();
      savedImage = imgData;
      savedEmail = emailAddress;
      document.getElementsByClassName("desktop__version")[0].style.height =
        tempHeight;
      console.log(
        "full img desktop--------------------------------------------------id"
      );
      SendDataToServer();
    });
  }
}

var savedImage_Local;
function SaveImageLocaly() {
  console.log("screenshot!");

  if (document.getElementById("modelViewD").style.display == "block") {
    //TURN OFF 3D VIEW
    var desktopNecklace2D = document.getElementById("braceletParent_Desktop");
    var mobileNecklace2D = document.getElementById("braceletParent_Mobile");

    var desktopNecklace3D = document.getElementById("modelViewD");
    var mobileNecklace3D = document.getElementById("modelViewM");

    var modelButtonMobile = document.getElementById("ModelButton_M");
    var modelButtonDekstop = document.getElementById("ModelButton_D");

    desktopNecklace2D.style.display = "";
    mobileNecklace2D.style.display = "";

    desktopNecklace3D.style.display = "table-column";
    mobileNecklace3D.style.display = "table-column";

    modelButtonMobile.style.backgroundImage =
      "url('{{ '3D.png' | asset_url }}')";
    modelButtonDekstop.style.backgroundImage =
      "url('{{ '3D.png' | asset_url }}')";
  }

  var mobileTutorial = document.getElementById("mobileTutorial");
  var desktopTutorial = document.getElementById("desktopTutorial");

  if (mobileTutorial != null) {
    if (mobileTutorial.style.display == "block") {
      mobileTutorial.style.display = "none";
    }
  }

  if (desktopTutorial != null) {
    if (desktopTutorial.style.display == "block") {
      desktopTutorial.style.display = "none";
    }
  }

  if (
    document.getElementsByClassName("desktop__version")[0].style.display ==
    "none"
  ) {
    // MOBILE VERSION
    const element = document.getElementById("resultsPage_M");
    var emailAddress = document.getElementById("email_M").value;
    html2canvas(element).then((canvas) => {
      const imgData = canvas.toDataURL();
      const link = document.createElement("a");
      link.download = "screenshot.png";
      link.href = imgData;
      link.click();
    });
  } else {
    // DESKTOP VERSION
    const element = document.getElementById("resultsPage");
    var emailAddress = document.getElementById("email_D").value;
    html2canvas(element).then((canvas) => {
      const imgData = canvas.toDataURL();
      const link = document.createElement("a");
      link.download = "screenshot.png";
      link.href = imgData;
      link.click();
    });
  }
}

var notesButton = document.getElementById("updateNotes");
var notesButtonM = document.getElementById("updateNotesM");

// notesButton.addEventListener('click', event => {
//   UpdateNotes();
// });

// notesButtonM.addEventListener('click', event => {
//   UpdateNotes();
// });

// function UpdateNotes(){
//   if(document.getElementsByClassName('desktop__version')[0].style.display == 'none'){
//     savedNotes = document.getElementById('notesM').value;

//     update(ref(database, 'users/' + firebaseEmailParent), {
//       notes: savedNotes
//     }).then();

//   }else{
//     savedNotes = document.getElementById('notes').value;

//     update(ref(database, 'users/' + firebaseEmailParent), {
//       notes: savedNotes
//     }).then();

//   }
// }

function UpdateNotes() {
  if (
    document.getElementsByClassName("desktop__version")[0].style.display ==
    "none"
  ) {
    // console.log("if TakeScreenShot---");
    savedNotes = document.getElementById("notesM").value;
    // console.log(savedNotes, "savedNotes");

    // get the updated data of the same object
    const userRef = ref(database, "users/" + firebaseEmailParent);
    get(userRef)
      .then((snapshot) => {
        if (snapshot.exists()) {
          const userData = snapshot.val();
          console.log("User data:", userData);

          //Write to sheets
          fetch(
            "https://script.google.com/macros/s/AKfycbxp4QMFvMiAWQ6CzEqI0oinZPGv84iwkMO7JgAWMZu4JxX4VRMF2ueRjsOLl8rd_a4M/exec",
            {
              method: "POST",
              mode: "no-cors",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ ...userData, isPrePurchase: true }),
            }
          )
            .then((response) => {
              // Since you're using 'no-cors', you can't read the response,
              // but you can confirm that the request was made.
              console.log("Data sent successfully.---mobile");
              $("body").addClass("quiz-loaded");
              // longData();
            })
            .catch((error) => {
              console.log("Fetch error: ", error);
            });
        } else {
          console.log("No data available for the specified user.");
        }
      })
      .catch((error) => {
        console.error("Failed to get user data:", error);
      });
  } else {
    //DESKTOP
    console.log("else TakeScreenShot---");
    savedNotes = document.getElementById("notes").value;

    const userRef = ref(database, "users/" + firebaseEmailParent);
    get(userRef)
      .then((snapshot) => {
        if (snapshot.exists()) {
          const userData = snapshot.val();
          console.log("User data:", userData);
          //var isPrePurchaseLocal = false;

          fetch(
            "https://script.google.com/macros/s/AKfycbxp4QMFvMiAWQ6CzEqI0oinZPGv84iwkMO7JgAWMZu4JxX4VRMF2ueRjsOLl8rd_a4M/exec",
            {
              method: "POST",
              mode: "no-cors",
              headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "POST",
                "Access-Control-Allow-Headers": "Content-Type",
              },
              body: JSON.stringify({ ...userData, isPrePurchase: true }),
            }
          )
            .then((response) => {
              // Since you're using 'no-cors', you can't read the response,
              // but you can confirm that the request was made.
              console.log("Data sent successfully.");
            })
            .catch((error) => {
              console.log("Fetch error: ", error);
            });
        } else {
          console.log("No data available for the specified user.");
        }
      })
      .catch((error) => {
        console.error("Failed to get user data:", error);
      });
  }
}
var orderImage;

function SendDataToServer() {
  const randomInteger = Math.floor(Math.random() * 100000) + 1;
  var imageName = "image" + randomInteger;
  var imagenameF = "imageF" + randomInteger;
  // var isStainless;
  // var includeB;
  // var onlyB;
  var name;
  var dateOfBirth;
  var day;
  var month;
  var year;

  var sunText;
  var risingText;
  var moonText;
  var mercuryText;
  var venusText;
  var marsText;
  var jupiterText;
  var saturnSaturnText;
  var uranusText;
  var neptuneText;
  var plutoText;

  var productSelector = document.querySelector(".mobile-quiz-order");
  var productname = productSelector.getAttribute("data-name");
  // console.log(productname,"productname"typeof productname);

  if (
    document.getElementsByClassName("desktop__version")[0].style.display ==
    "none"
  ) {
    name = document.getElementById("fname_M").value;
    savedNotes = document.getElementById("notesM").value;
    day = document.getElementById("date_D_M").value;
    month = document.getElementById("date_M_M").value;
    year = document.getElementById("date_Y_M").value;

    dateOfBirth = day + "/" + month + "/" + year;

    sunText = document.getElementById("sunTxt2").innerText;
    risingText = document.getElementById("risingTxt2").innerText;
    moonText = document.getElementById("moonTxt2").innerText;
    mercuryText = document.getElementById("mercuryTxt2").innerText;
    venusText = document.getElementById("venusTxt2").innerText;
    marsText = document.getElementById("marsTxt2").innerText;
    jupiterText = document.getElementById("jupiterTxt2").innerText;
    saturnSaturnText = document.getElementById("saturnTxt2").innerText;
    uranusText = document.getElementById("uranusTxt2").innerText;
    neptuneText = document.getElementById("neptuneTxt2").innerText;
    plutoText = document.getElementById("plutoTxt2").innerText;
  } else {
    // if(document.querySelector('#stainlessCheck input[type="checkbox"]') != null){
    //   isStainless = document.querySelector('#stainlessCheck input[type="checkbox"]').checked;
    // }
    // if(document.querySelector('#includeCheck input[type="checkbox"]') != null){
    //   includeB = document.querySelector('#includeCheck input[type="checkbox"]').checked;
    // }
    // if(document.querySelector('#braceletCheck input[type="checkbox"]') != null){
    //   onlyB = document.querySelector('#braceletCheck input[type="checkbox"]').checked;
    // }

    name = document.getElementById("fname_D").value;

    // savedNotes = document.getElementById("notes").value;
    savedNotes = "-";

    day = document.getElementById("date_D_D").value;
    month = document.getElementById("date_M_D").value;
    year = document.getElementById("date_Y_D").value;

    dateOfBirth = day + "/" + month + "/" + year;

    sunText = document.getElementById("sunTxt2").innerText;
    risingText = document.getElementById("risingTxt2").innerText;
    moonText = document.getElementById("moonTxt2").innerText;
    mercuryText = document.getElementById("mercuryTxt2").innerText;
    venusText = document.getElementById("venusTxt2").innerText;
    marsText = document.getElementById("marsTxt2").innerText;
    jupiterText = document.getElementById("jupiterTxt2").innerText;
    saturnSaturnText = document.getElementById("saturnTxt2").innerText;
    uranusText = document.getElementById("uranusTxt2").innerText;
    neptuneText = document.getElementById("neptuneTxt2").innerText;
    plutoText = document.getElementById("plutoTxt2").innerText;
  }

  // console.log(sRef)
  // console.log(storage)
  // console.log(imageName, "imageName");
  // console.log(imagenameF, "imageNamefull");
  // console.log(savedImage,'savedImage')
  // console.log(savedImagefull,'savedImagefull')

  // SHOW CROP QUIZ IMAGE
  uploadString(sRef(storage, imagenameF), savedImagefull, "data_url").then(
    (snapshot) => {
      getDownloadURL(sRef(storage, imagenameF))
        .then((url) => {
          orderImage = url;
          // console.log(url, "url----crop");
          // alert('get CROP url');
          // writeUserData(savedEmail, url, savedNotes, name, dateOfBirth, sunText, risingText, moonText, mercuryText, venusText, marsText, jupiterText , saturnSaturnText, uranusText, neptuneText, plutoText, productname);
          // writeUserData(savedEmail, url, savedNotes, name, dateOfBirth, sunText, risingText, moonText, mercuryText, venusText, marsText, jupiterText , saturnSaturnText, uranusText, neptuneText, plutoText);
          // writeUserData(savedEmail, url, savedNotes, isStainless, includeB, onlyB, name, dateOfBirth);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  );
  // SHOW FULL QUIZ IMAGE
  uploadString(sRef(storage, imageName), savedImage, "data_url").then(
    (snapshot) => {
      getDownloadURL(sRef(storage, imageName))
        .then((urlsec) => {
          // var orderImageFull = url;
          // console.log(urlsec, "urlsec----FULL");
          // alert('get url FULL');
          writeUserData(
            savedEmail,
            urlsec,
            savedNotes,
            name,
            dateOfBirth,
            sunText,
            risingText,
            moonText,
            mercuryText,
            venusText,
            marsText,
            jupiterText,
            saturnSaturnText,
            uranusText,
            neptuneText,
            plutoText,
            productname
          );
          // writeUserData(savedEmail, url, savedNotes, name, dateOfBirth, sunText, risingText, moonText, mercuryText, venusText, marsText, jupiterText , saturnSaturnText, uranusText, neptuneText, plutoText);
          // writeUserData(savedEmail, url, savedNotes, isStainless, includeB, onlyB, name, dateOfBirth);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  );
}
// console.log('test area.....',orderImage);
var includeB_global, onlyB_global;
// function writeUserData(email, imageUrl, notesS, stainless, includeB, onlyB, name, dateB) {
// function writeUserData(email, imageUrl, notesS, name, dateB) {
function writeUserData(
  email,
  imageUrl,
  notesS,
  name,
  dateB,
  sunText,
  risingText,
  moonText,
  mercuryText,
  venusText,
  marsText,
  jupiterText,
  saturnSaturnText,
  uranusText,
  neptuneText,
  plutoText,
  productname
) {
  // function writeUserData(email, imageUrl, notesS, name, dateB, sunText, risingText, moonText, mercuryText, venusText, marsText, jupiterText , saturnSaturnText, uranusText, neptuneText, plutoText) {
  var stringEmail = String(email);
  const randomInteger = Math.floor(Math.random() * 10000000000) + 1;
  stringEmail = stringEmail.replaceAll(".", ",");
  stringEmail = stringEmail + randomInteger;
  firebaseEmailParent = stringEmail;

  // includeB_global = includeB;
  // onlyB_global = onlyB;

  var currentDate = new Date();
  var dateCurr =
    currentDate.getDate() +
    "/" +
    (currentDate.getMonth() + 1) +
    "/" +
    currentDate.getFullYear();
  newID = generateRandomString();
  console.log(
    "newID---*---------------------------------------------------------",
    newID
  );
  // console.log(
  //   "imageUrl---*---------------------------------------------------------",
  //   imageUrl
  // );

  //   if(includeB_global == false && onlyB_global == false)
  //   productName = 'NECKLACE CHART'
  // else if(includeB_global == true && onlyB_global == false)
  //   productName = 'NECKLACE CHART & BRACELET CHART'
  // else if(includeB_global == false && onlyB_global == true)
  //   productName = 'BRACELET CHART'

  document.getElementById("userID").innerText = newID;
  document.getElementById("productName").innerText = productName;

  set(ref(database, "users/" + stringEmail), {
    name: name,
    dateOfBirth: dateB,
    id: newID,
    email: email,
    profile_picture: imageUrl,
    // notes: notesS,
    // stainless: false,
    // includeBracelet: false,
    // onlyBracelet: false,
    // fulfilled: false,
    // verified: false,
    date: dateCurr,
    // sun: sunText,
    // rising: risingText ,
    // moon: moonText,
    // mercury: mercuryText ,
    // venus: venusText ,
    // mars: marsText,
    // jupiter: jupiterText ,
    // saturn: saturnSaturnText ,
    // uranus: uranusText,
    // neptune: neptuneText,
    // pluto: plutoText,
    productname: productname,
  })
    .then(SaveUsersDataInMemory())
    .then(UpdateNotes());
}
// console.log('newID---',newID)
async function SaveUsersDataInMemory() {
  event.preventDefault();
  console.log("=====Write users data to memory=====");

  var usersData = JSON.parse(localStorage.getItem("usersData")) || [];
  var id = "";
  var name = "";

  // Wait for the id and name variables to have values
  while (id === "" || name === "") {
    id = document.getElementById("userID").innerText;
    name = document.getElementById("productName").innerText;
    await new Promise((resolve) => setTimeout(resolve, 100)); // Wait 100ms before checking again
  }

  var newProduct = {
    ID: id,
    name: name,
  };

  console.log("New USER DATA input");
  console.log(newProduct);

  usersData.push(newProduct);
  localStorage.setItem("usersData", JSON.stringify(usersData));

  document.getElementById("backendCheck").style.backgroundColor = "red";

  // window.location.href='https://www.shoptenthhouse.com/products/necklace-chart';
}

function generateRandomString() {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  for (let i = 0; i < 10; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

// ------------ custom js-----------------------------------------------------------------------------------------------------------------

// change loop flow mobile
if ("PendingQuizM" in localStorage) {
  let loopData = localStorage.getItem("PendingQuizM");
  window.history.pushState(
    { page: "another" },
    "another page",
    "/pages/new-quiz?pendingquiz=" + loopData + ""
  );
}

// discount mobile
if (document.querySelector(".discount_popup_Mopener") != null) {
  document
    .querySelector(".discount_popup_Mopener")
    .addEventListener("click", function (event) {
      // this.style.opacity = "0.5";
      // let loader = this.querySelector(".loader");
      // console.log(loader, "loader----");
      // loader.style.display = "inline-block";

      // data add to excel
      // TakeScreenShot();
      // data add to excel ends
      // make first bundle check
      let checkFirst = document.getElementById("oneM");
      checkFirst.checked = true;

      const sectionQuiz = document.getElementById("product-quiz-new");
      if (sectionQuiz) {
        sectionQuiz.scrollIntoView({ behavior: "smooth" });
      }
      // window.scrollTo({ top: 0, behavior: "smooth" });
      let popUpM = document.querySelector(".discount_popup_M");
      popUpM.classList.add("open");

      let hideResult = document.querySelector("#resultsStepM .step__bracelet");
      // hideResult.style.display = "none";
      hideResult.style = "opacity:0;position:absolute;z-index:-1;";
      // hideResult.style.position = "absolute";
      // hideResult.style.z-index = "-1";

      let hideResultHeading = document.querySelector(
        "#resultsStepM .quiz_result_text"
      );
      hideResultHeading.style.display = "none";
    });
}

let quizQty = JSON.parse(localStorage.getItem("QuizData")) || [];
let quizLength = parseInt(quizQty.length);
// console.log(quizLength,"quizLength--",typeof quizLength);

document.querySelectorAll(".selected-product-id").forEach(function (event) {
  // console.log("event-----", event);
  event.setAttribute("data-qty", quizLength);
});

// if(quizLength == 2){
//   bundleTwo.classList.add('disbled-btn');
// }
// else if(quizLength >= 3){
//   bundleTwo.classList.add('disbled-btn');
//   bundleThree.classList.add('disbled-btn');
// }

let bundleDiscount = document.querySelector("#resultsStepM .bundle_discount ");
let nextCheckout = document.querySelector(".next-checkout-btn");
let selectQty = document.querySelector(".quiz-loop-btn");
let currentURL = window.location.href;
let bundleOne = document.querySelector(".one-product-m");
let bundleTwo = document.querySelector(".two-product-m");
let bundleThree = document.querySelector(".three-product-m");

// if (currentURL.includes("pendingquiz")) {
//   bundleDiscount.classList.add('disbled-btn');
//   // nextCheckout.classList.add('disbled-btn');
//   // selectQty.classList.remove('disbled-btn');
// }
// else{
//   bundleDiscount.classList.remove('disbled-btn');
//   // nextCheckout.classList.remove('disbled-btn');
// }

document
  .querySelectorAll('input[name="quizdiscountM"]')
  .forEach(function (event) {
    event.addEventListener("change", function (e) {
      let Quizcount = parseInt(
        document.querySelector('input[name="quizdiscountM"]:checked').value
      );
      console.log(Quizcount, "Quizcount--", typeof Quizcount);

      let nextCheckout = document.querySelector(".mobile-bundle-checkout");
      // console.log(nextCheckout, "nextCheckout--", typeof nextCheckout);

      // if (Quizcount > 1) {
      //   if (nextCheckout.classList.contains("direct-add-cart-M","next-checkout-btn")){
      //     nextCheckout.classList.remove("direct-add-cart-M","next-checkout-btn");
      //   }
      //   nextCheckout.classList.add("quiz-loop-btn");
      // }
      // else {
      //   if (nextCheckout.classList.contains("quiz-loop-btn")){
      //     nextCheckout.classList.remove("quiz-loop-btn");
      //   }
      //   nextCheckout.classList.add("direct-add-cart-M", "next-checkout-btn");
      // }

      let hasQuiz = currentURL.includes("pendingquiz");
      // console.log(hasQuiz,"hasQuiz--",typeof hasQuiz);

      // if (hasQuiz) {
      //   // console.log('hasQuiz--')
      // }
      // else{
      //   // console.log('hasQuiz--else')
      //    if(Quizcount > 1 ){
      //       console.log('if')
      //         selectQty.classList.remove('disbled-btn');
      //         nextCheckout.classList.add('disbled-btn');
      //    }
      //    else{
      //         console.log('else')
      //        selectQty.classList.add('disbled-btn');
      //        nextCheckout.classList.remove('disbled-btn');
      //    }

      // }
      // if (currentURL.includes("pendingquiz=1")) {
      //   if (Quizcount == 2 ){
      //     // console.log('hasQuiz--Quizcount == 2')
      //     nextCheckout.classList.remove('disbled-btn');
      //   }
      //   else if(Quizcount == 3 ){
      //     // console.log('hasQuiz--Quizcount == 3')
      //      selectQty.classList.remove('disbled-btn');
      //      nextCheckout.classList.add('disbled-btn');
      //   }
      // }
    });
  });

// hide last step if 2 qty already available
// let hidePopup = document.querySelector(".discount_popup_Mopener");
// let addcheckoutBtn = document.querySelector(".last-checkout");
// let quizNum = addcheckoutBtn.getAttribute("data-qty");
// if(quizNum >= 2 ){
//   addcheckoutBtn.style.display = 'flex' ;
//   addcheckoutBtn.classList.add('next-checkout-btn');
//   hidePopup.style.display = 'none' ;
// }
// else{
//   addcheckoutBtn.classList.remove('next-checkout-btn');
//   // addcheckoutBtn.style.display = 'none' ;
//   // hidePopup.style.display = 'block' ;
// }

// if loop pending default select the product
// let totalquizQty = JSON.parse(localStorage.getItem("TotalQuiz")) || [];
// if(totalquizQty != [] ){
//   document.querySelectorAll('input[name="quizdiscountM"]').forEach(function (event) {
//     // console.log(totalquizQty,"totalquizQty--",typeof totalquizQty);

//     let selectedRadio = document.querySelector('input.bundleRadio[value="'+totalquizQty+'"]');
//     // console.log(selectedRadio,"selectedRadio--",typeof selectedRadio);
//     if(selectedRadio != null){
//       selectedRadio.checked = true;
//     }
//   })
// }
//

// if (currentURL.includes("pendingquiz=1")) {
//   // bundleDiscount.classList.remove('disbled-btn');
//   // bundleDiscount.classList.add('disbled-btn');

//   selectQty.classList.add('disbled-btn');
//   nextCheckout.classList.remove('disbled-btn');
//   bundleOne.style.display = 'none' ;
// }
// else if(currentURL.includes("pendingquiz=2")) {
//   // bundleDiscount.classList.add('disbled-btn');

//   selectQty.classList.remove('disbled-btn');
// }

// ----new js
// mobile

document.querySelectorAll(".mobile-quiz-order").forEach(function (e) {
  e.addEventListener("click", function (event) {

    let loader = this.querySelector(".loader");
    console.log(loader, "loader----");
    loader.style.display = "inline-block";
    this.style.opacity = "0.5";
    
    TakeScreenShot();

    var moneyFormat = document
      .getElementById("currency-info")
      .getAttribute("data-currency-symbol");
    // var parts = moneyFormat.split("{{");

    // Regex to extract the currency symbol (either at the start or the end)
    // let regex = /^[^\s{]+|[^\s{]+(?=\s*$)/;
    let regex = /^[^\s{}]+|[^\s{}]+(?=[\s{}]*$)/;

    // Extract the currency symbol
    let match = moneyFormat.match(regex);
    let Symbol = match ? match[0] : null;
    // console.log(Symbol, "Symbol--");

    // Determine the position of the currency symbol (start or end)
    let currencyPosition;
    if (moneyFormat.startsWith(Symbol)) {
      currencyPosition = "start";
    } else if (moneyFormat.endsWith(Symbol)) {
      currencyPosition = "end";
    } else {
      currencyPosition = "unknown";
    }
    // console.log(currencyPosition, "currencyPosition--");

    let splitRegex = new RegExp(`\\s*${Symbol}\\s*`);
    let [leftPart, rightPart] = moneyFormat.split(splitRegex);

    // Only trim and check for spaces if the format had spaces around the symbol
    let finalSymbol = Symbol;
    if (/\s/.test(moneyFormat)) {
      leftPart = leftPart ? leftPart.trim() : "";
      rightPart = rightPart ? rightPart.trim() : "";

      // Example of how you might use the left and right parts
      if (leftPart) {
        finalSymbol = " " + Symbol;
      }
      if (rightPart) {
        finalSymbol = Symbol + " ";
      }
    }

    let currencySymbol = finalSymbol;
    // var parts = moneyFormat.split("{{");
    // var currencySymbol = parts[0].trim();
    console.log(currencySymbol, "currencySymbol---");

    // get product price
    var giftPrice;
    $.getJSON("/products/gift-box", function (e) {
      var edata = e.product.variants;
      for (let index = 0; index < edata.length; index++) {
        giftPrice = edata[index].price;
      }
    });

    var warrantyPrice;
    $.getJSON("/products/insured", function (e) {
      var edata = e.product.variants;
      for (let index = 0; index < edata.length; index++) {
        warrantyPrice = edata[index].price;
      }
    });
    // console.log(warrantyPrice,"warrantyPrice")
    var braceletPrice;
    var braceletCompareprice;
    $.getJSON("/products/bracelet-chart", function (e) {
      var edata = e.product.variants;
      for (let index = 0; index < edata.length; index++) {
        braceletPrice = edata[index].price;
        braceletCompareprice = edata[index].compare_at_price;
        console.log(edata, "edata---");
        console.log(braceletPrice, "braceletPrice");
        console.log(braceletCompareprice, "braceletCompareprice");
      }
    });

    // get product price

    // setTimeout(
    function checkAndExecute() {
      if ($("body").hasClass("quiz-loaded")) {
        clearInterval(checkInterval);
        afterSs();
      }
    }
    function afterSs() {
      console.log("working----after screenshot");
      const sectionQuiz = document.getElementById("product-quiz-new");
      if (sectionQuiz) {
        sectionQuiz.scrollIntoView({ behavior: "smooth" });
      }
      loader.style.display = "none";

      var quizQty = JSON.parse(localStorage.getItem("QuizData")) || [];
      var quizLength = parseInt(quizQty.length);
      console.log(quizLength, "quizLength--");

      if (document.querySelector('input[name="quizdiscountM"]:checked')) {
        let selectQty = document.querySelector(
          'input[name="quizdiscountM"]:checked'
        ).value;
        localStorage.setItem("TotalQuiz", selectQty);
      }
      let totalQty = localStorage.getItem("TotalQuiz") || [];
      let valueQty = parseInt(totalQty);
      console.log(valueQty, "valueQty--data");
      // console.log("checked");

      let cartQty = event.target.getAttribute("data-qty");
      // console.log(cartQty, "cartQty");

      let loopPending = valueQty - cartQty - 1;
      console.log(loopPending, "loopPending");

      // data add to excel ends
      event.target.setAttribute("data-qty", quizLength);

      let cartQt = event.target.getAttribute("data-qty");
      console.log(cartQt, "cartQt");
      let popUpM = document.querySelector(".discount_popup_M");

      if (valueQty == 2) {
        console.log("cartQty is---------2");
        if (!popUpM.classList.contains("d-none")) {
          if (!(loopPending == 0)) {
            if (cartQt < 3) {
              document.body.classList.add("quiz-page-M");
            }
          }
        } else {
          let currentURLs = window.location.href;
          if (currentURLs.includes("pendingquiz=2")) {
            document.body.classList.add("quiz-page-M");
          }
        }
        if (cartQty <= loopPending) {
          console.log("yes---------2", loopPending, typeof loopPending);
          localStorage.setItem("PendingQuizM", loopPending);

          let productIdM = event.target.getAttribute("data-id");
          console.log(productIdM, "productIdM-------");
        }
      } else if (valueQty == 3) {
        console.log("cartQty is---------3");
        if (!popUpM.classList.contains("d-none")) {
          if (!(loopPending == 0)) {
            document.body.classList.add("quiz-page-M");
          }
        } else {
          let currentURLs = window.location.href;
          if (currentURLs.includes("pendingquiz=2")) {
            document.body.classList.add("quiz-page-M");
          }
        }
        if (cartQty <= loopPending) {
          console.log("yes---------3", loopPending, typeof loopPending);
          localStorage.setItem("PendingQuizM", loopPending);
        }
      }

      // ---- add to cart product on quiz order - now
      // console.log("working");
      // var quizList = JSON.parse(localStorage.getItem("QuizData")) || [];
      let itemsList = [];
      let variantId = event.target.getAttribute("data-id");
      // console.log(variantId, "variantId");

      // value of form-----
      var nameFirst = document.getElementById("fname_M").value;
      var hbirth = document.getElementById("hbirth_M").value;
      var mbirth = document.getElementById("mbirth_M").value;
      var date_d = document.getElementById("date_D_M").value;
      var date_m = document.getElementById("date_M_M").value;
      var date_y = document.getElementById("date_Y_M").value;
      var city = document.getElementById("city_M").value;
      var email = document.getElementById("email_M").value;
      // value of colors------
      var sunText = document.getElementById("sunTxt2").innerText;
      var risingText = document.getElementById("risingTxt2").innerText;
      // console.log(risingText, "risingText");
      var moonText = document.getElementById("moonTxt2").innerText;
      var mercuryText = document.getElementById("mercuryTxt2").innerText;
      var venusText = document.getElementById("venusTxt2").innerText;
      var marsText = document.getElementById("marsTxt2").innerText;
      var jupiterText = document.getElementById("jupiterTxt2").innerText;
      var saturnSaturnText = document.getElementById("saturnTxt2").innerText;
      var uranusText = document.getElementById("uranusTxt2").innerText;
      var neptuneText = document.getElementById("neptuneTxt2").innerText;
      var plutoText = document.getElementById("plutoTxt2").innerText;
      // console.log(newID,"newID---");
      var quizmadeIdM = newID;
      // console.log(quizmadeIdM,"quizmadeIdM-----------");
      var orderimageM = orderImage;
      // console.log(orderimageM,"orderimageM---");

      var productHandle = event.target.getAttribute("data-handle");
      // var productFinalprice = event.target.getAttribute("data-fprice") ;
      // console.log(productFinalprice,"productFinalprice---");
      // var productcompareprice = event.target.getAttribute("data-cprice") ;
      // console.log(productcompareprice,"productcompareprice---");
      var productName = event.target.getAttribute("data-name");
      // console.log(productName,"productName---");
      // var productCurrency = event.target.getAttribute("data-currency") ;
      // console.log(productCurrency,"productCurrency---");

      let localSet = {
        id: variantId,
        name: nameFirst,
        birthhour: hbirth,
        birthminute: mbirth,
        birthdate: date_d,
        birthmonth: date_m,
        birthyear: date_y,
        city: city,
        email: email,
        sunText: sunText,
        risingText: risingText,
        moonText: moonText,
        mercuryText: mercuryText,
        venusText: venusText,
        marsText: marsText,
        jupiterText: jupiterText,
        saturnSaturnText: saturnSaturnText,
        uranusText: uranusText,
        neptuneText: neptuneText,
        plutoText: plutoText,
        productHandle: productHandle,
        // productFinalprice : productFinalprice ,
        // productcompareprice : productcompareprice ,
        productName: productName,
        // productCurrency:productCurrency,
        quizmadeIdM: quizmadeIdM,
        orderimageM: orderimageM,
      };
      quizQty.push(localSet);
      var values = JSON.stringify(quizQty);
      localStorage.setItem("QuizData", values);

      // -----------
      let obj = {
        quantity: 1,
        id: variantId,
        properties: {
          Quizid: quizmadeIdM,
          OrderImage: orderimageM,
        },
      };
      itemsList.push(obj);

      const FormData = {
        items: itemsList,
      };

      let quizList = JSON.parse(localStorage.getItem("QuizData")) || [];
      let QuizCount = parseInt(quizList.length);
      // console.log(QuizCount,"QuizCount--inside---");
      document
        .querySelectorAll(".selected-product-id")
        .forEach(function (event) {
          event.setAttribute("data-qty", QuizCount);
        });
      let bundleDiscount = document.querySelector(
        "#resultsStepM .bundle_discount "
      );
      let nextCheckout = document.querySelector(".next-checkout-btn");
      let selectQtybtn = document.querySelector(".quiz-loop-btn");
      let currentURL = window.location.href;

      let bundleOne = document.querySelector(".one-product-m");
      let bundleTwo = document.querySelector(".two-product-m");
      let bundleThree = document.querySelector(".three-product-m");

      // if(QuizCount == 2){
      //   bundleTwo.classList.add('disbled-btn');
      //   selectQtybtn.classList.add('disbled-btn');
      // }
      // else if(QuizCount >= 3){
      //   bundleTwo.classList.add('disbled-btn');
      //   bundleThree.classList.add('disbled-btn');
      //   selectQtybtn.classList.add('disbled-btn');
      //   selectQtybtn.classList.add('disbled-btn');
      //   nextCheckout.classList.remove('disbled-btn');
      // }

      if (loopPending < 1) {
        if (currentURL.includes("pendingquiz=1")) {
          localStorage.removeItem("PendingQuizM");

          var modifiedURL = currentURL.split("?pendingquiz")[0];
          // var modifiedURL = currentURL.split("?productId")[0];
          // console.log(modifiedURL,"modifiedURL---");
          window.history.replaceState({}, document.title, modifiedURL);
          //
          // bundleDiscount.classList.remove('disbled-btn');
          // selectQtybtn.classList.add('disbled-btn');
          // nextCheckout.classList.remove('disbled-btn');
        }
      }
      // for open last page
      if ("PendingQuizM" in localStorage) {
        let loopData = localStorage.getItem("PendingQuizM");
        console.log(loopData, "loopData------------");
        console.log(valueQty, "valueQty------------");

        if (valueQty == 2) {
          if (cartQty <= loopPending) {
            console.log("yes---------2 success");

            window.location.reload();
            // setTimeout(function () {
            // }, 2000);

            window.history.pushState(
              { page: "another" },
              "another page",
              "/pages/new-quiz?pendingquiz=" + loopData + ""
            );
          }
        } else if (valueQty == 3) {
          if (cartQty <= loopPending) {
            console.log("yes---------3 success");

            // setTimeout(function () {
            window.location.reload();
            // }, 2000);
            window.history.pushState(
              { page: "another" },
              "another page",
              "/pages/new-quiz?pendingquiz=" + loopData + ""
            );
          }
        }
      }

      // last page data
      let lastPage = document.querySelector(".quiz-cart-page");
      if (event.target.classList.contains("next-checkout-btn")) {
        let parentPopup = document.querySelector(".discount_popup_M");
        parentPopup.classList.remove("open");
        lastPage.style.display = "block";
        lastPage.classList.add("pre-checkout-page");
      }
      let hasQyery = window.location.search.includes("pendingquiz=");
      if (event.target.classList.contains("last-checkout")) {
        if (hasQyery == false) {
          // alert('yess--222');
          let hideResult = document.querySelector(
            "#resultsStepM .step__bracelet"
          );
          hideResult.style.display = "none";
          let hideResultHeading = document.querySelector(
            "#resultsStepM .quiz_result_text"
          );
          hideResultHeading.style.display = "none";
          lastPage.style.display = "block";
          lastPage.classList.add("pre-checkout-page");
        }
      }
      // hide show bracelet-box
      let braceletBundle = document.querySelector(".show-bracelet-box");
      let setLabel = braceletBundle.closest("label");
      // console.log(braceletBundle,"braceletBundle--",typeof braceletBundle)
      let braceletBundleBox = document.querySelector(".quiz-bracelet-data");
      // console.log(braceletBundleBox,"braceletBundleBox--")

      // show data
      for (var i = 0; i < quizQty.length; i++) {
        $.getJSON("/products/" + quizQty[i].productHandle + "", function (e) {
          var edata = e.product.variants;
          let productPrice;
          let productComparePrice;

          for (let index = 0; index < edata.length; index++) {
            productPrice = edata[index].price;
            productComparePrice = edata[index].compare_at_price;
          }
          console.log(productPrice, "productPrice");
          console.log(productComparePrice, "productComparePrice");

          let html = "";
          for (var i = 0; i < quizQty.length; i++) {
            html +=
              '<div class="quiz-cart-products shadow-products-box quiz-added-products" ';
            html +=
              ' data-name="' +
              quizQty[i].name +
              '" data-id="' +
              quizQty[i].id +
              '"data-Fval="Gold"';
            if (quizQty[i].productHandle == "bracelet-chart") {
              html += 'data-Sval="20cm" data-pid="44874616995999" ';
            } else {
              html += 'data-Sval="45cm" data-pid="44874618208415" ';
            }
            if (
              quizQty[i].productHandle ==
              "personaloised-braceleet-necklace-chart"
            ) {
              html += 'data-BSval="20cm" data-BFval="Gold"';
            }
            html +=
              'data-sun="' +
              quizQty[i].sunText +
              '" data-rising="' +
              quizQty[i].risingText +
              '" data-moon="' +
              quizQty[i].moonText +
              '" data-mercury="' +
              quizQty[i].mercuryText +
              '" data-venus="' +
              quizQty[i].venusText +
              '" data-mars="' +
              quizQty[i].marsText +
              '" data-jupiter="' +
              quizQty[i].jupiterText +
              '" data-saturn="' +
              quizQty[i].saturnSaturnText +
              '" data-uranus="' +
              quizQty[i].uranusText +
              '" data-neptune="' +
              quizQty[i].neptuneText +
              '" data-pluto="' +
              quizQty[i].plutoText +
              '" data-uniqId="' +
              quizQty[i].quizmadeIdM +
              '" data-img="' +
              quizQty[i].orderimageM +
              '">';
            html += '<div class="quiz-cart-product-main"> ';
            html += ' <div class="quiz-cart-product-left"> ';
            html += '<div class="quiz-cart-product-img"> ';
            html += ' <img src="' + quizQty[i].orderimageM + '">';
            html += "</div> ";
            html += '<div class="quiz-cart-product-result"> ';
            html += '<ul class="planetList"> ';
            html += " <li> ";
            html += '<span class="newsunTxt">' + quizQty[i].sunText + "</span>";
            html += "</li> ";
            html += "<li> ";
            html +=
              ' <span class="newrisingTxt">' +
              quizQty[i].risingText +
              "</span> ";
            html += " </li> ";
            html += "<li>";
            html +=
              '  <span class="newmoonTxt">' + quizQty[i].moonText + "</span> ";
            html += " </li> ";
            html += "<li> ";
            html +=
              '<span class="newmercuryTxt">' +
              quizQty[i].mercuryText +
              "</span> ";
            html += " </li> ";
            html += "<li> ";
            html +=
              '<span class="newvenusTxt">' + quizQty[i].venusText + "</span> ";
            html += " </li> ";
            html += " <li> ";
            html +=
              ' <span class="newmarsTxt">' + quizQty[i].marsText + "</span> ";
            html += " </li> ";
            html += " <li> ";
            html +=
              '  <span class="newjupiterTxt">' +
              quizQty[i].jupiterText +
              "</span> ";
            html += " </li> ";
            html += " <li> ";
            html +=
              ' <span class="newsaturnTxt">' +
              quizQty[i].saturnSaturnText +
              "</span> ";
            html += " </li> ";
            html += "<li> ";
            html +=
              '  <span class="newuranusTxt">' +
              quizQty[i].uranusText +
              "</span> ";
            html += "  </li> ";
            html += " <li> ";
            html +=
              ' <span class="newneptuneTxt">' +
              quizQty[i].neptuneText +
              "</span> ";
            html += " </li> ";
            html += "<li> ";
            html +=
              ' <span class="newplutoTxt">' + quizQty[i].plutoText + "</span> ";
            html += "</li> ";
            html += "</ul> ";
            html += ' <a class="next">Show More</a> ';
            html += "  </div> ";
            html += "</div>";
            html += ' <div class="quiz-cart-product-right"> ';
            html +=
              " <h3><span>" +
              quizQty[i].name +
              "'s </span> Custom " +
              quizQty[i].productName +
              "</h3> ";
            html += ' <div class="quiz-cart-product-price"> ';
            html += '<div class="quiz-cart-product-price-left"> ';
            html +=
              '<span class="final_price" data-fPrice="' + productPrice + '"> ';
            if (currencyPosition === "start") {
              html += "" + currencySymbol + "" + productPrice + "";
            } else if (currencyPosition === "end") {
              html += "" + productPrice + "" + currencySymbol + "";
            }
            html += " </span> ";
            html += '<span class="compare_price"> ';
            if (currencyPosition === "start") {
              html += "" + currencySymbol + "" + productComparePrice + "";
            } else if (currencyPosition === "end") {
              html += "" + productComparePrice + "" + currencySymbol + " ";
            }
            html += " </span> ";
            html += "</div>";
            html += '<div class="quiz-cart-product-price-right"> ';
            html += ' <span class="bundle-name"> ';
            html += "  </span> ";
            html += " </div> ";
            html += " </div> ";
            if (
              quizQty[i].productHandle ==
              "personaloised-braceleet-necklace-chart"
            ) {
              html += ' <div class=""><b>Necklace</b></div> ';
            }
            html += ' <div class="quiz-cart-product-variant"> ';
            html += ' <div class="quiz-product-variant"> ';
            html += " <span>Finish:</span> ";
            html += ' <div class="quiz-cart-product-variant-details"> ';
            html +=
              '    <label class="checked-finish">Gold<input class="selected-variant" type="radio" value="Gold" name="variantFM-' +
              i +
              '" checked></label> ';
            html +=
              '  <label >Silver<input class="selected-variant" type="radio" value="Silver" name="variantFM-' +
              i +
              '" ></label> ';
            html += " </div> ";
            html += " </div> ";

            html += ' <div class="quiz-product-variant"> ';
            html += "  <span>Size:</span> ";
            html += ' <div class="quiz-cart-product-variant-details"> ';
            html += ' <label  class="checked-size">';
            if (quizQty[i].productHandle == "bracelet-chart") {
              html += "20 cm";
            } else {
              html += "45 cm";
            }
            html += '<input class="selected-size" type="radio" ';
            if (quizQty[i].productHandle == "bracelet-chart") {
              html += 'value="20cm" ';
            } else {
              html += 'value="45cm" ';
            }
            html += 'name="variantSM-' + i + '" checked></label> ';
            html += " <label>";
            if (quizQty[i].productHandle == "bracelet-chart") {
              html += "25 cm";
            } else {
              html += "50 cm";
            }
            html += '<input class="selected-size" type="radio" ';
            if (quizQty[i].productHandle == "bracelet-chart") {
              html += 'value="25cm"';
            } else {
              html += 'value="50cm"';
            }
            html += 'name="variantSM-' + i + '" ></label> ';
            html += "</div> ";
            html += "</div> ";
            html += "</div> ";
            // barcelet
            if (
              quizQty[i].productHandle ==
              "personaloised-braceleet-necklace-chart"
            ) {
              html += ' <div class=""><b>Bracelet</b></div> ';
              html += ' <div class="quiz-cart-product-variant"> ';
              html += ' <div class="quiz-product-variant"> ';
              html += " <span>Finish:</span> ";
              html += ' <div class="quiz-cart-product-variant-details"> ';
              html +=
                '    <label class="checked-finish-bn">Gold<input class="selected-variant-fbn" type="radio" value="Gold" name="variantFM-' +
                i +
                '" checked></label> ';
              html +=
                '  <label >Silver<input class="selected-variant-fbn" type="radio" value="Silver" name="variantFM-' +
                i +
                '" ></label> ';
              html += " </div> ";
              html += " </div> ";
              html += ' <div class="quiz-product-variant"> ';
              html += "  <span>Size:</span> ";
              html += ' <div class="quiz-cart-product-variant-details"> ';
              html +=
                ' <label class="checked-size-bn">20 cm<input class="selected-size-sbn" type="radio" value="20cm"  name="variantSM-' +
                i +
                '" checked></label> ';
              html +=
                ' <label>25 cm<input class="selected-size-sbn" type="radio" value="25cm"  name="variantSM-' +
                i +
                '" ></label> ';
              html += "</div> ";
              html += "</div> ";
              html += "</div> ";
            }
            // barcelet
            html += '<div class="quiz-cart-product-add"> ';
            if (quizQty[i].productHandle != "bracelet-chart") {
              html += '  <div class="quiz-cart-product-packing"> ';
              html += '  <label class="checked-pack"> ';
              html += "<div> ";
              html +=
                '<input class="selected-packing" type="radio" value="44874618208415"  name="packingM-' +
                i +
                '" checked> ';
              html += '  <span class="selected-packing-radio"></span> ';
              html += "   <span>Gift Packaging</span> ";
              html += " </div> ";
              html += '<div> <span class="giftpacking_price"';
              html += ' data-Gprice="' + giftPrice + '"';
              html += ' data-currency="' + currencySymbol + '"> ';
              if (currencyPosition === "start") {
                html += "" + currencySymbol + "" + giftPrice + " </span></div>";
              } else if (currencyPosition === "end") {
                html +=
                  "" + giftPrice + "" + currencySymbol + " </span></div> ";
              }
              html += " </label> ";
              html += "  <label> ";
              html += "  <div> ";
              html +=
                '<input class="selected-packing" type="radio" value="44874616995999"  name="packingM-' +
                i +
                '" > ';
              html += '  <span class="selected-packing-radio"></span> ';
              html += " <span>Original Packaging</span> ";
              html += " </div> ";
              html += " <div><span>Free</span></div> ";
              html += "</label> ";
              html += "</div> ";
            }
            html += ' <div class="quiz-cart-product-lifetime"> ';
            html += '   <label class="warrenty_switch"> ';
            html += "  <div> ";
            html +=
              ' <input type="checkbox" name="lifetimeWarranty" value="54884495065470" class="select-warranty"> ';
            html += '  <span class="selected-leftetime-checkbox"></span> ';
            html += " <span>Lifetime Warranty</span> ";
            html += " </div> ";
            html +=
              ' <div><span class="warranty_price" data-currency="' +
              currencySymbol +
              '" data-Wprice="' +
              warrantyPrice +
              '" data-position="' +
              currencyPosition +
              '"> ';
            if (currencyPosition === "start") {
              html +=
                " " + currencySymbol + "" + warrantyPrice + " </span></div> ";
            } else if (currencyPosition === "end") {
              html +=
                " " + warrantyPrice + "" + currencySymbol + " </span></div> ";
            }
            html += " </label> ";
            html += " </div> ";
            html += " </div> ";
            html += "</div> ";
            html += "</div> ";
            html += " </div> ";
          }
          document.querySelector(".quiz-data").innerHTML = html;
        });
      }

      // bracelet data
      var quizQty = JSON.parse(localStorage.getItem("QuizData")) || [];
      let productID = "";
      for (var i = 0; i < quizQty.length; i++) {
        productID = parseInt(quizQty[0].id);
      }
      // console.log(productID,"productID*---");
      let braceletMain = document.querySelector(".quiz-cart-products-add");
      let braceletMainBox = document.querySelector(".quiz-bracelet-data");
      if (productID === 44494026866847) {
        let htmlBracelet = "";
        for (var i = 0; i < quizQty.length; i++) {
          htmlBracelet +=
            ' <div class="shadow-products-box quiz-option-products">';
          htmlBracelet += '<div class="quiz-cart-product-main">';
          htmlBracelet += ' <div class="quiz-cart-product-left">';
          htmlBracelet += '<div class="quiz-cart-product-img">';
          htmlBracelet += ' <img src="' + quizQty[i].orderimageM + '">';
          htmlBracelet += " </div>";
          htmlBracelet += ' <div class="quiz-cart-product-result">';
          htmlBracelet += '  <ul class="planetList">';
          htmlBracelet += " <li><span>" + quizQty[i].sunText + "</span></li>";
          htmlBracelet +=
            " <li><span>" + quizQty[i].risingText + "</span></li>";
          htmlBracelet += " <li><span>" + quizQty[i].moonText + "</span></li>";
          htmlBracelet +=
            " <li><span>" + quizQty[i].mercuryText + "</span></li>";
          htmlBracelet +=
            "  <li><span>" + quizQty[i].venusText + "</span></li>";
          htmlBracelet += " <li><span>" + quizQty[i].marsText + "</span></li>";
          htmlBracelet +=
            " <li><span>" + quizQty[i].jupiterText + "</span></li>";
          htmlBracelet +=
            " <li><span>" + quizQty[i].saturnSaturnText + "</span></li>";
          htmlBracelet +=
            "  <li><span>" + quizQty[i].uranusText + "</span></li>";
          htmlBracelet +=
            " <li><span>" + quizQty[i].neptuneText + "</span></li>";
          htmlBracelet += " <li><span>" + quizQty[i].plutoText + "</span></li>";
          htmlBracelet += "</ul>";
          htmlBracelet += '<a class="next">Show More</a>';
          htmlBracelet += "</div>";
          htmlBracelet += "</div>";
          htmlBracelet += '  <div class="quiz-cart-product-right">';
          htmlBracelet +=
            " <h3><span>" +
            quizQty[i].name +
            "'s</span> Custom Bracelet Chart</h3>";
          htmlBracelet += '  <div class="quiz-cart-product-price">';
          htmlBracelet += '  <div class="quiz-cart-product-price-left">';
          htmlBracelet += "  <span>";
           if (currencyPosition === "start") {
            htmlBracelet += "" + currencySymbol + "" + braceletPrice + "";
          } else if (currencyPosition === "end") {
            htmlBracelet += "" + braceletPrice + "" + currencySymbol + "";
          }
          htmlBracelet += " </span>";
          htmlBracelet += '<span class="compare_price">';
          if (currencyPosition === "start") {
            htmlBracelet +=
              "" + currencySymbol + "" + braceletCompareprice + "";
          } else if (currencyPosition === "end") {
            htmlBracelet +=
              "" + braceletCompareprice + "" + currencySymbol + " ";
          }
          htmlBracelet += " </span>";
          htmlBracelet += " </div>";
          htmlBracelet += " </div>";
          htmlBracelet += ' <div class="quiz-cart-product-variant"> ';
          htmlBracelet += ' <div class="quiz-product-variant"> ';
          htmlBracelet += " <span>Finish:</span> ";
          htmlBracelet += ' <div class="quiz-cart-product-variant-details"> ';
          htmlBracelet +=
            '    <label class="checked-finish-b">Gold<input class="selected-variant-b" type="radio" value="Gold" name="variantFM-' +
            i +
            '" checked></label> ';
          htmlBracelet +=
            '  <label >Silver<input class="selected-variant-b" type="radio" value="Silver" name="variantFM-' +
            i +
            '" ></label> ';
          htmlBracelet += " </div> ";
          htmlBracelet += " </div> ";
          htmlBracelet += ' <div class="quiz-product-variant"> ';
          htmlBracelet += " <span>Size:</span> ";
          htmlBracelet += ' <div class="quiz-cart-product-variant-details"> ';
          htmlBracelet +=
            '    <label class="checked-size-b">20 cm<input class="selected-size-b" type="radio" value="20cm" name="variantSM-' +
            i +
            '" checked></label> ';
          htmlBracelet +=
            '    <label >25 cm<input class="selected-size-b" type="radio" value="25cm" name="variantSM-' +
            i +
            '" ></label> ';
          htmlBracelet += " </div> ";
          htmlBracelet += " </div> ";
          htmlBracelet += "</div>";
          htmlBracelet += ' <div class="quiz-bracelet-product"> ';
          htmlBracelet +=
            '  <a class="regular-btn bracelet-add" data-name="' +
            quizQty[i].name +
            '" data-Cid="42459357151391" data-Scval="20cm" data-Fcval="Gold" data-Bprice="' +
            braceletPrice +
            '" data-uniqId="' +
            quizQty[i].quizmadeIdM +
            '"  ';
          htmlBracelet +=
            'data-sun="' +
            quizQty[i].sunText +
            '" data-rising="' +
            quizQty[i].risingText +
            '" data-moon="' +
            quizQty[i].moonText +
            '" data-mercury="' +
            quizQty[i].mercuryText +
            '" data-venus="' +
            quizQty[i].venusText +
            '" data-mars="' +
            quizQty[i].marsText +
            '" data-jupiter="' +
            quizQty[i].jupiterText +
            '" data-saturn="' +
            quizQty[i].saturnSaturnText +
            '" data-uranus="' +
            quizQty[i].uranusText +
            '" data-neptune="' +
            quizQty[i].neptuneText +
            '" data-pluto="' +
            quizQty[i].plutoText +
            '" data-img="' +
            quizQty[i].orderimageM +
            '">';
          htmlBracelet += " Add to Cart</a> ";
          htmlBracelet +=
            '  <a class="regular-btn bracelet-remove" data-Rid="42459357151391" data-Bprice="' +
            braceletPrice +
            '">';
          htmlBracelet += "remove</a> ";
          htmlBracelet += "</div>";
          htmlBracelet += "</div>";
          htmlBracelet += " </div>";
          htmlBracelet += "</div>";
        }
        braceletMainBox.innerHTML = htmlBracelet;
      } else {
        braceletMain.style.display = "none";
      }
      // show data
      // if (braceletBundleBox != null) {
      //   if (QuizCount > 1) {
      //     braceletBundleBox.style.display = "none";
      //     setLabel.classList.add("checked-bracelet");
      //   } else {
      braceletBundleBox.style.display = "block";
      setLabel.classList.remove("checked-bracelet");
      //   }
      // }
      // change text
      let bundleText = document.querySelectorAll(".bundle-name");
      if (bundleText != null) {
        bundleText.forEach(function (event) {
          if (QuizCount == 2) {
            event.innerHTML = "SOULMATE BOUNDLE";
          } else if (QuizCount >= 3) {
            event.innerHTML = "FAMILY BOUNDLE";
          }
        });
      }

      // total price of page
      setTimeout(function () {
        let totalPrice = 0;
        let currency = "";

        document
          .querySelectorAll(".quiz-cart-products")
          .forEach(function (event) {
             let warrantyPrice = 0 ;
            
            if(event.querySelector(".warrenty_switch").classList.contains('checked-warranty')){
              warrantyPrice = parseFloat(event.querySelector(".warranty_price").getAttribute("data-Wprice"));
            }
            // console.log(event.querySelector(".select-warranty:checked"),"warreanty checkbox");
            console.log(warrantyPrice, "warrantyPrice", typeof warrantyPrice);
            // let warrantyPrice = parseFloat(
            //   event.querySelector(".warranty_price").getAttribute("data-Wprice")
            // );
            // console.log(warrantyPrice, "warrantyPrice", typeof warrantyPrice);

            currency = event
              .querySelector(".warranty_price")
              .getAttribute("data-currency");
            // console.log(currency, "currency");
            currencyPosition = event
              .querySelector(".warranty_price")
              .getAttribute("data-position");
            // console.log(currency, "currency");

            let finalPrice = event
              .querySelector(".final_price")
              .getAttribute("data-fPrice");
            finalPrice = parseFloat(finalPrice);
            // console.log(finalPrice, "finalPrice", typeof finalPrice);

            if (event.querySelector(".giftpacking_price") != null) {
              let giftpackingPrice = parseFloat(
                event
                  .querySelector(".giftpacking_price")
                  .getAttribute("data-Gprice")
              );
              // console.log(
              //   giftpackingPrice,
              //   "giftpackingPrice",
              //   typeof giftpackingPrice
              // );
              totalPrice += warrantyPrice + giftpackingPrice + finalPrice;
            } else {
              totalPrice += warrantyPrice + finalPrice;
            }
            // console.log(
            //   totalPrice,
            //   "Accumulated totalPrice",
            //   typeof totalPrice
            // );
          });
        // console.log(totalPrice, "Final totalPrice");

        // Update the total span
        if (currencyPosition === "start") {
          document.querySelector(".currency").innerHTML = currency;
          let hideOther = document.querySelector(".currency-back");
          hideOther.display = "none";
          let parentStyle = document.querySelector(".quiz-subtotal-span");
          // parentStyle.style.display = "inline-flex";
          parentStyle.style.display = "inline-block";
        } else if (currencyPosition === "end") {
          document.querySelector(".currency-back").innerHTML = currency;
          let hideOthers = document.querySelector(".currency");
          hideOthers.display = "none";
        }
        document.querySelector(".quiz-total").innerHTML = totalPrice.toFixed(2);
        document
          .querySelector(".quiz-total")
          .setAttribute("data-subtotal", totalPrice.toFixed(2));

        // if cart price available
        const cartData = document.querySelectorAll(".quiz-cart-product");
        // console.log(cartData,"cartData---");

        if (cartData.length > 0) {
          let QuizTotal = 0;
          let subTotal = parseFloat(
            document.querySelector(".quiz-total").getAttribute("data-subtotal")
          );
          let cartTotal = parseFloat(
            document
              .querySelector(".cart-total")
              .getAttribute("data-cart-total")
          );
          QuizTotal += subTotal + cartTotal;

          let QuizTotalDiv = document.querySelector(".total-price-pay");
          QuizTotalDiv.innerHTML = QuizTotal.toFixed(2);
          QuizTotalDiv.setAttribute("data-total-price", QuizTotal.toFixed(2));
        }
      }, 2000);
      // last page data
      $("body").removeClass("quiz-loaded");
    }
    // , 6000);
    // afterSs();
    var checkInterval = setInterval(checkAndExecute, 1000);
  });
});

// radios onchange - last quiz page
$(document).on("change", ".quiz-cart-products input", function () {
  // product size variant on change
  // console.log('test area.')
  var setVal = $(this).closest(".quiz-cart-products");
  var selectVariant = setVal.find(".selected-variant:checked");
  var selectVariantVal = selectVariant.val();
  var setLabel = selectVariant.closest("label");
  setVal.attr("data-fval", selectVariantVal);
  setLabel.addClass("checked-finish").siblings().removeClass("checked-finish");

  // product finish variant on change
  var selectSize = setVal.find(".selected-size:checked");
  var selectSizeVal = selectSize.val();
  var setLabelSize = selectSize.closest("label");
  setVal.attr("data-sval", selectSizeVal);
  setLabelSize.addClass("checked-size").siblings().removeClass("checked-size");

  // bracelet for 2 mix product
  var selectVariantSbn = setVal.find(".selected-size-sbn:checked");
  var selectVariantValSbn = selectVariantSbn.val();
  var setLabelSbn = selectVariantSbn.closest("label");
  setVal.attr("data-BSval", selectVariantValSbn);
  setLabelSbn
    .addClass("checked-size-bn")
    .siblings()
    .removeClass("checked-size-bn");

  // product finish variant on change
  var selectVariantFbn = setVal.find(".selected-variant-fbn:checked");
  var selectVariantValFbn = selectVariantFbn.val();
  var setLabelFbn = selectVariantFbn.closest("label");
  setVal.attr("data-BFval", selectVariantValFbn);
  setLabelFbn
    .addClass("checked-finish-bn")
    .siblings()
    .removeClass("checked-finish-bn");
});

// product packaging on change
$(document).on(
  "change",
  '.quiz-cart-products input[name^="packingM-"]',
  function () {
    var setVal = $(this).closest(".quiz-cart-products");
    var selectPack = setVal.find(".selected-packing:checked");
    var selectpackVal = selectPack.val();
    var setLabelpack = selectPack.closest("label");
    setVal.attr("data-pid", selectpackVal);
    setLabelpack
      .addClass("checked-pack")
      .siblings()
      .removeClass("checked-pack");

    // Update total
    let totalSpan = parseFloat(
      $(".quiz-total")
        .text()
        .replace(/,/g, "")
        .replace(/[^0-9.-]+/g, "")
    );
    // $('.quiz-cart-products').each(function() {
    let giftpackingPrice = parseFloat(
      setVal.find(".giftpacking_price").data("gprice")
    );
    // let giftpackingPrice = parseFloat(setVal.find('.giftpacking_price').data('gprice').replace(/,/g, ''));
    if (selectpackVal == 44874616995999) {
      totalSpan -= giftpackingPrice;
    } else {
      totalSpan += giftpackingPrice;
    }
    // });
    $(".quiz-total").text(totalSpan.toFixed(2));

    let mainParent = $(this).closest(".pre-checkout-page");
    // console.log(mainParent, "mainParent---");

    if ($(".quiz-cart-product").length > 0) {
      // console.log("settimeout----add packingM");

      setTimeout(function () {
        // let cartTotal = fetchCartTotal();
        // let cartTotal =  parseFloat(mainParent.find('.cart-total').text());
        let cartTotal = parseFloat(mainParent.find(".total-price-pay").text());
        // console.log(cartTotal, "cartTotal", typeof cartTotal);

        console.log(totalSpan, "totalSpan----", typeof totalSpan);
        let FinalTotal = 0;
        if (selectpackVal == 44874616995999) {
          // console.log(
          //   giftpackingPrice,
          //   "giftpackingPrice",
          //   typeof giftpackingPrice
          // );
          FinalTotal = cartTotal - giftpackingPrice;
        } else {
          // console.log(
          //   giftpackingPrice,
          //   "giftpackingPrice",
          //   typeof giftpackingPrice
          // );
          FinalTotal = cartTotal + giftpackingPrice;
        }
        $(".total-price-pay").html(FinalTotal.toFixed(2));
        $(".total-price-pay").attr("data-total-price", FinalTotal.toFixed(2));
        // setTimeout(function () {
        //   }, 500)
      }, 1000);
    }
  }
);

// product warranty change
$(document).on(
  "change",
  '.quiz-cart-products input[name="lifetimeWarranty"]',
  function () {
    // Product warranty change
    let setVal = $(this).closest(".quiz-cart-products");
    let selectWarr = setVal.find(".select-warranty:checked");
    let setLabelWarr = setVal.find(".select-warranty").closest("label");

    // Parse the initial total from the span using jQuery
    let totalSpan = parseFloat(
      $(".quiz-total")
        .text()
        .replace(/,/g, "")
        .replace(/[^0-9.-]+/g, "")
    );
    // let warrantyPrice = parseFloat(setVal.find('.warranty_price').data('wprice').replace(/,/g, ''));
    let warrantyPrice = parseFloat(
      setVal.find(".warranty_price").data("wprice")
    );

    let mainParent = $(this).closest(".pre-checkout-page");
    // console.log(mainParent, "mainParent---");
    if (this.checked) {
      // console.log('checked----');
      let selectWarrVal = selectWarr.val();
      setVal.attr("data-wid", selectWarrVal);
      setLabelWarr.addClass("checked-warranty");
      totalSpan += warrantyPrice;
    } else {
      // console.log('unchecked----');
      setVal.removeAttr("data-wid");
      setLabelWarr.removeClass("checked-warranty");
      totalSpan -= warrantyPrice;
    }
    $(".quiz-total").text(totalSpan.toFixed(2));
    let warrentyBtn = $(this);
    // console.log(warrentyBtn,"warrentyBtn",typeof warrentyBtn);

    if ($(".quiz-cart-product").length > 0) {
      // console.log("settimeout----add warrenty");

      setTimeout(function () {
        // let cartTotal =  parseFloat(mainParent.find('.cart-total').data('cart-total'));
        // let cartTotal =  parseFloat(mainParent.find('.cart-total').text());
        let cartTotal = parseFloat(mainParent.find(".total-price-pay").text());
        // console.log(cartTotal, "cartTotal", typeof cartTotal);

        // console.log(totalSpan,"totalSpan----",typeof totalSpan)
        // console.log(warrentyBtn, "warrentyBtn", typeof warrentyBtn);

        let FinalTotal = 0;
        if (warrentyBtn.is(":checked")) {
          // console.log('warrebty ---checked')

          // console.log(warrantyPrice, "warrantyPrice", typeof warrantyPrice);
          FinalTotal = cartTotal + warrantyPrice;
        } else {
          // console.log('warrebty ---unchecked')
          // console.log(warrantyPrice, "warrantyPrice", typeof warrantyPrice);
          FinalTotal = cartTotal - warrantyPrice;
        }
        $(".total-price-pay").html(FinalTotal.toFixed(2));
        $(".total-price-pay").attr("data-total-price", FinalTotal.toFixed(2));
      }, 1000);
    }
  }
);

// prevent on load heading btn
// document.querySelector(".heading-btn").addEventListener("click", function (event) {
//    event.preventDefault()
// })

// hide show bracelet-box
let braceletBundle = document.querySelector(".show-bracelet-box");
let setLabel = braceletBundle.closest("label");
// console.log(braceletBundle,"braceletBundle--",typeof braceletBundle)
let braceletBundleBox = document.querySelector(".quiz-bracelet-data");
// console.log(braceletBundleBox,"braceletBundleBox--")
let quizList = JSON.parse(localStorage.getItem("QuizData")) || [];
let QuizCount = parseInt(quizList.length);
// if (braceletBundleBox != null) {
//   if (QuizCount > 1) {
//     braceletBundleBox.style.display = "none";
//     setLabel.classList.add("checked-bracelet");
//   } else {
//     braceletBundleBox.style.display = "block";
//     setLabel.classList.remove("checked-bracelet");
//   }
// }

document
  .querySelector(".show-bracelet-box")
  .addEventListener("change", function (event) {
    let setLabel = this.closest("label");
    if (this.checked) {
      // console.log('cheked')
      braceletBundleBox.style.display = "none";
      setLabel.classList.add("checked-bracelet");
    } else {
      // console.log('cheked---not')
      braceletBundleBox.style.display = "block ";
      setLabel.classList.remove("checked-bracelet");
    }
  });

// change text of bundle name
let bundleText = document.querySelectorAll(".bundle-name");
if (bundleText != null) {
  bundleText.forEach(function (event) {
    if (QuizCount == 2) {
      event.innerHTML = "SOULMATE BOUNDLE";
    } else if (QuizCount >= 3) {
      event.innerHTML = "FAMILY BOUNDLE";
    }
  });
}

// bracelet on change
$(document).on("change", ".quiz-option-products input", function () {
  // finish variant
  var setVal = $(this).closest(".quiz-option-products").find(".bracelet-add");
  var selectVariant = $(this)
    .closest(".quiz-option-products")
    .find(".selected-variant-b:checked");
  var selectVariantVal = selectVariant.val();
  var setLabel = selectVariant.closest("label");
  setVal.attr("data-fcval", selectVariantVal);
  setLabel
    .addClass("checked-finish-b")
    .siblings()
    .removeClass("checked-finish-b");

  // size variant
  var selectSize = $(this)
    .closest(".quiz-option-products")
    .find(".selected-size-b:checked");
  var selectSizeVal = selectSize.val();
  var setSizeLabel = selectSize.closest("label");
  setVal.attr("data-scval", selectSizeVal);
  setSizeLabel
    .addClass("checked-size-b")
    .siblings()
    .removeClass("checked-size-b");
});

// bracelete add to cart
$(document).on("click", ".bracelet-add", function (event) {
  event.preventDefault();

  // price add
  let totalSpanText = $(".quiz-total").text();
  let totalSpan = parseFloat(
    totalSpanText.replace(/,/g, "").replace(/[^0-9.-]+/g, "")
  );
  console.log(totalSpan, "totalSpan--", typeof totalSpan);

  let productPriceText = parseFloat($(this).attr("data-Bprice"));

  let productPrice = parseFloat(productPriceText);
  console.log(productPrice, "productPrice--", typeof productPrice);

  totalSpan += productPrice;
  $(".quiz-total").text(totalSpan.toFixed(2));

  let mainParent = $(this).closest(".pre-checkout-page");
  // console.log(mainParent, "mainParent---");

  if ($(".quiz-cart-product").length > 0) {
    console.log("settimeout----add");

    setTimeout(function () {
      // let cartTotal =  parseFloat(mainParent.find('.cart-total').data('cart-total'));
      // let cartTotal =  parseFloat(mainParent.find('.cart-total').text());
      let cartTotal = parseFloat(mainParent.find(".total-price-pay").text());
      console.log(cartTotal, "cartTotal", typeof cartTotal);

      // console.log(totalSpan,"totalSpan----",typeof totalSpan)
      // let FinalTotal = totalSpan + cartTotal ;
      let FinalTotal = cartTotal + productPrice;

      $(".total-price-pay").html(FinalTotal.toFixed(2));
      $(".total-price-pay").attr("data-total-price", FinalTotal.toFixed(2));
      // setTimeout(function () {
      // }, 500)
    }, 1000);
  }
  // price add

  let productId = parseInt($(this).data("cid"));
  // console.log(productId, "productId--", typeof productId);

  let selectSize = $(this).data("scval");
  // console.log("selectSize", selectSize, typeof selectSize);

  let selectFinish = $(this).data("fcval");
  // console.log("selectFinish", selectFinish, typeof selectFinish);

  // planet data
  var nameCust = $(this).data("name");
  var sunText = $(this).data("sun");
  var risingText = $(this).data("rising");
  var moonText = $(this).data("moon");
  var mercuryText = $(this).data("mercury");
  var venusText = $(this).data("venus");
  var marsText = $(this).data("mars");
  var jupiterText = $(this).data("jupiter");
  var saturnSaturnText = $(this).data("saturn");
  var uranusText = $(this).data("uranus");
  var neptuneText = $(this).data("neptune");
  var plutoText = $(this).data("pluto");
  var orderimageM = $(this).data("img");
  var quizmadeIdB = $(this).data("uniqid");
  console.log(quizmadeIdB, "quizmadeIdB", typeof quizmadeIdB);
  var bundleId = `idB-${quizmadeIdB}`;
  console.log(bundleId, "bundleId", typeof bundleId);
  // planet data

  const formData = {
    items: [
      {
        id: productId,
        quantity: 1,
        properties: {
          "Select Bracelet Finish": selectFinish,
          "Select Bracelet Size": selectSize,
          Name: nameCust,
          Sun: sunText,
          Rising: risingText,
          Moon: moonText,
          Mercury: mercuryText,
          Venus: venusText,
          Mars: marsText,
          Jupiter: jupiterText,
          Saturn: saturnSaturnText,
          Uranus: uranusText,
          Neptune: neptuneText,
          Pluto: plutoText,
          OrderImage: orderimageM,
          bundleId: bundleId,
        },
      },
    ],
  };
  console.log("formData", formData, typeof formData);
  let clickedElement = $(this);

  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      return response.json();
    })
    .then((cartData) => {
      console.log("add to cart bracelet");

      let RemoveBtn = clickedElement.next(".bracelet-remove");
      // console.log(RemoveBtn, "RemoveBtn---");
      RemoveBtn.css("display", "inline-flex");

      let Removeitem = cartData.items.find(
        (item) => item.variant_id === productId
      );
      if (Removeitem) {
        // console.log('clickedElement', clickedElement.next('.bracelet-remove'));
        clickedElement
          .next(".bracelet-remove")
          .attr("data-key", Removeitem.key);
      }
      clickedElement.css("display", "none");
    })
    .catch((error) => {
      console.error("Error:", error);
    });
});

// bracelet remove
$(document).on("click", ".bracelet-remove", function (e) {
  e.preventDefault();

  // Price remove
  let totalSpanText = $(".quiz-total").text();
  let totalSpan = parseFloat(
    totalSpanText.replace(/,/g, "").replace(/[^0-9.-]+/g, "")
  );
  console.log(totalSpan, "totalSpan--", typeof totalSpan);

  let productPriceText = $(this).attr("data-Bprice");
  let productPrice = parseFloat(productPriceText);
  // let productPrice = parseFloat(productPriceText.replace(/,/g, ""));
  console.log(productPrice, "productPrice--", typeof productPrice);

  totalSpan -= productPrice;
  $(".quiz-total").text(totalSpan.toFixed(2));

  let mainParent = $(this).closest(".pre-checkout-page");
  console.log(mainParent, "mainParent---");

  if ($(".quiz-cart-product").length > 0) {
    console.log("settimeout----remove");

    setTimeout(function () {
      // let cartTotal =  parseFloat(mainParent.find('.cart-total').data('cart-total'));
      // let cartTotal =  parseFloat(mainParent.find('.cart-total').text());
      let cartTotal = parseFloat(mainParent.find(".total-price-pay").text());
      console.log(cartTotal, "cartTotal", typeof cartTotal);

      // console.log(totalSpan,"totalSpan----",typeof totalSpan)

      // let FinalTotal = totalSpan + cartTotal ;
      let FinalTotal = cartTotal - productPrice;

      $(".total-price-pay").html(FinalTotal.toFixed(2));
      $(".total-price-pay").attr("data-total-price", FinalTotal.toFixed(2));
      // setTimeout(function () {
      // }, 500)
    }, 1000);
  }

  let productId = parseInt($(this).attr("data-Rid"));
  // console.log(productId, "productId--", typeof productId);

  let itemKey = $(this).attr("data-key");
  // console.log(itemKey, "itemKey--", typeof itemKey);

  let clickedElement = this;

  $.ajax({
    type: "POST",
    url: `/cart/change?id=${itemKey}&quantity=0`,
    dataType: "json",
    success: function (cartData) {
      let addBtn = $(clickedElement).prev();
      addBtn.css("display", "inline-flex");
      $(clickedElement).hide();
    },
  });
});

// add to cart and open checkout page
document.querySelectorAll(".final-checkout").forEach(function (e) {
  e.addEventListener("click", function (event) {
    event.preventDefault();
    let itemsList = [];
    document.querySelectorAll(".quiz-cart-products").forEach(function (event) {
      let productId = parseInt(event.getAttribute("data-id"));
      let selectPacking = parseInt(event.getAttribute("data-pid"));
      let selectWarrenty = parseInt(event.getAttribute("data-wid"));
      let selectSize = event.getAttribute("data-Sval");
      let selectFinish = event.getAttribute("data-Fval");
      let selectSizeB = event.getAttribute("data-BSval");
      let selectFinishB = event.getAttribute("data-BFval");
      // planet data
      var nameCust = event.getAttribute("data-name");
      var sunText = event.getAttribute("data-sun");
      var risingText = event.getAttribute("data-rising");
      var moonText = event.getAttribute("data-moon");
      var mercuryText = event.getAttribute("data-mercury");
      var venusText = event.getAttribute("data-venus");
      var marsText = event.getAttribute("data-mars");
      var jupiterText = event.getAttribute("data-jupiter");
      var saturnSaturnText = event.getAttribute("data-saturn");
      var uranusText = event.getAttribute("data-uranus");
      var neptuneText = event.getAttribute("data-neptune");
      var plutoText = event.getAttribute("data-pluto");
      var quizmadeIdM = event.getAttribute("data-uniqId");
      var orderimageM = event.getAttribute("data-img");
      var bundleId = `id-${quizmadeIdM}`;
      console.log(bundleId, "bundleId", typeof bundleId);
      // planet data

      itemsList.push(
        {
          id: productId,
          quantity: 1,
          properties: {
            Name: nameCust,
            "Select Finish": selectFinish,
            "Select Size": selectSize,
            "Select Bracelet Finish": selectFinishB,
            "Select Bracelet Size": selectSizeB,
            Sun: sunText,
            Rising: risingText,
            Moon: moonText,
            Mercury: mercuryText,
            Venus: venusText,
            Mars: marsText,
            Jupiter: jupiterText,
            Saturn: saturnSaturnText,
            Uranus: uranusText,
            Neptune: neptuneText,
            Pluto: plutoText,
            Quizid: quizmadeIdM,
            OrderImage: orderimageM,
            bundleId: bundleId,
          },
        },
        {
          id: selectPacking,
          quantity: 1,
          properties: {
            Name: nameCust,
            bundleId: bundleId,
          },
        }
      );
      if (event.hasAttribute("data-wid")) {
        itemsList.push({
          id: selectWarrenty,
          quantity: 1,
          properties: {
            Name: nameCust,
            bundleId: bundleId,
          },
        });
      }
    });

    console.log(itemsList, "itemsList--");
    const formData = {
      items: itemsList,
    };

    console.log(FormData, "FormData--");

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        if (response.status && response.status === "error") {
          console.error("Error adding to cart:", response.message);
          return;
        }
        localStorage.removeItem("QuizData");
        localStorage.removeItem("TotalQuiz");
        const sectionQuiz = document.getElementById("product-quiz-new");
        if (sectionQuiz) {
          sectionQuiz.scrollIntoView({ behavior: "smooth" });
        }
        
        setTimeout(function () {
          document.location.href = "/cart/checkout";
        }, 2000);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  });
});

// continue shopping btn click
document.querySelectorAll(".continue-shopping").forEach(function (event) {
  event.addEventListener("click", function (e) {
    e.preventDefault();
    let getLocation = this.getAttribute("href");
    console.log(getLocation, "getLocation--");

    let itemsList = [];
    document.querySelectorAll(".quiz-cart-products").forEach(function (event) {
      let productId = parseInt(event.getAttribute("data-id"));
      let selectPacking = parseInt(event.getAttribute("data-pid"));
      let selectWarrenty = parseInt(event.getAttribute("data-wid"));
      let selectSize = event.getAttribute("data-Sval");
      let selectFinish = event.getAttribute("data-Fval");
      let selectSizeB = event.getAttribute("data-BSval");
      let selectFinishB = event.getAttribute("data-BFval");

      // planet data
      var nameCust = event.getAttribute("data-name");
      var sunText = event.getAttribute("data-sun");
      var risingText = event.getAttribute("data-rising");
      var moonText = event.getAttribute("data-moon");
      var mercuryText = event.getAttribute("data-mercury");
      var venusText = event.getAttribute("data-venus");
      var marsText = event.getAttribute("data-mars");
      var jupiterText = event.getAttribute("data-jupiter");
      var saturnSaturnText = event.getAttribute("data-saturn");
      var uranusText = event.getAttribute("data-uranus");
      var neptuneText = event.getAttribute("data-neptune");
      var plutoText = event.getAttribute("data-pluto");
      var quizmadeIdM = event.getAttribute("data-uniqId");
      var orderimageM = event.getAttribute("data-img");
      var bundleId = `id-${quizmadeIdM}`;
      console.log(bundleId, "bundleId", typeof bundleId);
      // planet data

      itemsList.push(
        {
          id: productId,
          quantity: 1,
          properties: {
            Name: nameCust,
            "Select Finish": selectFinish,
            "Select Size": selectSize,
            "Select Bracelet Finish": selectFinishB,
            "Select Bracelet Size": selectSizeB,
            Sun: sunText,
            Rising: risingText,
            Moon: moonText,
            Mercury: mercuryText,
            Venus: venusText,
            Mars: marsText,
            Jupiter: jupiterText,
            Saturn: saturnSaturnText,
            Uranus: uranusText,
            Neptune: neptuneText,
            Pluto: plutoText,
            Quizid: quizmadeIdM,
            OrderImage: orderimageM,
            bundleId: bundleId,
          },
        },
        {
          id: selectPacking,
          quantity: 1,
          properties: {
            Name: nameCust,
            bundleId: bundleId,
          },
        }
      );
      if (event.hasAttribute("data-wid")) {
        itemsList.push({
          id: selectWarrenty,
          quantity: 1,
          properties: {
            Name: nameCust,
            bundleId: bundleId,
          },
        });
      }
    });

    console.log(itemsList, "itemsList--");
    const formData = {
      items: itemsList,
    };

    console.log(FormData, "FormData--");

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        console.log(response, "response---");
        // localStorage.removeItem('QuizData');
        // localStorage.removeItem('TotalQuiz');
        // document.location.href = '/pages/new-quiz';
        const sectionQuiz = document.getElementById("product-quiz-new");
        if (sectionQuiz) {
          sectionQuiz.scrollIntoView({ behavior: "smooth" });
        }
        document.location.href = getLocation;
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  });
});

// remove data
if (window.location.href.indexOf("/pages/new-quiz?pendingquiz") === -1) {
  // alert("working-data-remove");
  localStorage.removeItem("QuizData");
  localStorage.removeItem("TotalQuiz");
  document.querySelectorAll(".selected-product-id").forEach(function (btnAdd) {
    btnAdd.setAttribute("data-qty", 0);
  });
}

// get cart data
function cartData() {
  // console.log("working---");
  const cartItemsContainer = document.querySelector(
    ".quiz-cart-products-added"
  );
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      // console.log('cart----', cart);

      if (cart.items.length > 0) {
        const moneyFormat = document
          .getElementById("currency-info")
          .getAttribute("data-currency-symbol");
        // Regex to extract the currency symbol (either at the start or the end)
        // let regex = /^[^\s{]+|[^\s{]+(?=\s*$)/;
        let regex = /^[^\s{}]+|[^\s{}]+(?=[\s{}]*$)/;

        // Extract the currency symbol
        let match = moneyFormat.match(regex);
        let Symbol = match ? match[0] : null;
        // console.log(Symbol, "Symbol--");

        // Determine the position of the currency symbol (start or end)
        let currencyPosition;
        if (moneyFormat.startsWith(Symbol)) {
          currencyPosition = "start";
        } else if (moneyFormat.endsWith(Symbol)) {
          currencyPosition = "end";
        } else {
          currencyPosition = "unknown";
        }
        // console.log(currencyPosition, "currencyPosition--");

        let splitRegex = new RegExp(`\\s*${Symbol}\\s*`);
        let [leftPart, rightPart] = moneyFormat.split(splitRegex);

        // Only trim and check for spaces if the format had spaces around the symbol
        let finalSymbol = Symbol;
        if (/\s/.test(moneyFormat)) {
          leftPart = leftPart ? leftPart.trim() : "";
          rightPart = rightPart ? rightPart.trim() : "";

          // Example of how you might use the left and right parts
          if (leftPart) {
            finalSymbol = " " + Symbol;
          }
          if (rightPart) {
            finalSymbol = Symbol + " ";
          }
        }
        let currencySymbol = finalSymbol;
        // const parts = moneyFormat.split("{{");
        // const currencySymbol = parts[0].trim();
        // console.log(currencySymbol, "currencySymbol---");

        // bundle product code
        const bundleItems = new Map();
        let cartIndex = 0;

        cart.items.forEach((item) => {
          let bundleId = "";

          Object.entries(item.properties).forEach(([key, value]) => {
            if (key === "bundleId") {
              bundleId = value;
            }
          });

          if (bundleId) {
            if (!bundleItems.has(bundleId)) {
              bundleItems.set(bundleId, []);
            }
            bundleItems.get(bundleId).push({ ...item, cartIndex });
            cartIndex++;
          }
        });
        // console.log(bundleItems, "bundleItems", typeof bundleItems);

        let dataCart = "";

        // Bundle products section
        dataCart += `<h3 class="cart-pre-head">Remember, you also have <br> inside your cart :</h3> <div class="cart-product-list bundle-product">`;
        bundleItems.forEach((items, bundleId) => {
          dataCart += `<div class="shadow-products-box quiz-option-products">`;
          dataCart += `<div class="quiz-bundle-list">`;

          // cart.items.forEach((item,itemIndex) => {
          items.forEach((item, itemIndex) => {
            dataCart += `<div class="quiz-cart-product-main quiz-cart-product">
                  <div class="quiz-cart-product-left">
                      <a href="javascript:void(0)" `;
            if (item.handle.includes("chart")) {
              dataCart += `class="cart-custom-remove main-product"`;
            } else {
              dataCart += `class="cart-custom-remove"`;
            }
            dataCart += `data-product-id="${item.id}" data-key="${
              item.key
            }" data-price="${(item.final_line_price / 100).toFixed(
              2
            )}" data-index="${item.cartIndex}" rel="${item.id}">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" id="cancel"><path fill="#212121" d="M2.58859116,2.7156945 L2.64644661,2.64644661 C2.82001296,2.47288026 3.08943736,2.45359511 3.2843055,2.58859116 L3.35355339,2.64644661 L8,7.293 L12.6464466,2.64644661 C12.8417088,2.45118446 13.1582912,2.45118446 13.3535534,2.64644661 C13.5488155,2.84170876 13.5488155,3.15829124 13.3535534,3.35355339 L8.707,8 L13.3535534,12.6464466 C13.5271197,12.820013 13.5464049,13.0894374 13.4114088,13.2843055 L13.3535534,13.3535534 C13.179987,13.5271197 12.9105626,13.5464049 12.7156945,13.4114088 L12.6464466,13.3535534 L8,8.707 L3.35355339,13.3535534 C3.15829124,13.5488155 2.84170876,13.5488155 2.64644661,13.3535534 C2.45118446,13.1582912 2.45118446,12.8417088 2.64644661,12.6464466 L7.293,8 L2.64644661,3.35355339 C2.47288026,3.17998704 2.45359511,2.91056264 2.58859116,2.7156945 L2.64644661,2.64644661 L2.58859116,2.7156945 Z"/></svg>
                    </a>
                    <div class="quiz-cart-product-img">`;
            dataCart += `<img src="${item.featured_image.url}" alt="${item.featured_image.alt}">
                    </div>
                  </div>
                </div>`;
          });

          dataCart += `</div> <div class="quiz-cart-product-right">`;
          items.forEach((item, itemIndex) => {
            // cart.items.forEach((item, itemIndex) => {
            dataCart += `<div class="cart-order" `;
            if (item.handle.includes("chart")) {
              dataCart += `style="order:1; margin-bottom: 10px;"><h3>`;
            } else if (item.handle.includes("gift")) {
              dataCart += `style="order:2"><h3>
                    <span class="check-svg">
                     <svg
                          class="icon icon-checkmark color-foreground-{{ settings.accent_icons }}"
                          aria-hidden="true"
                          focusable="false"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 12 9"
                          fill="none"
                        >
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M11.35.643a.5.5 0 01.006.707l-6.77 6.886a.5.5 0 01-.719-.006L.638 4.845a.5.5 0 11.724-.69l2.872 3.011 6.41-6.517a.5.5 0 01.707-.006h-.001z" fill="currentColor"/>
                        </svg>
                     </span>`;
            } else {
              dataCart += `style="order:3"><h3>
                 <span class="check-svg">
                 <svg
                      class="icon icon-checkmark color-foreground-{{ settings.accent_icons }}"
                      aria-hidden="true"
                      focusable="false"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 12 9"
                      fill="none"
                    >
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M11.35.643a.5.5 0 01.006.707l-6.77 6.886a.5.5 0 01-.719-.006L.638 4.845a.5.5 0 11.724-.69l2.872 3.011 6.41-6.517a.5.5 0 01.707-.006h-.001z" fill="currentColor"/>
                    </svg>
                 </span>`;
            }
            dataCart += `<span>`;

            Object.entries(item.properties).forEach(([key, value]) => {
              if (key.includes("Name")) {
                dataCart += ` ${value}'s`;
              }
            });

            dataCart += ` Custom ${
              item.title.charAt(0).toUpperCase() + item.title.slice(1)
            }
                    </span>
                  </h3>`;
            if (item.handle.includes("chart")) {
              dataCart += `<div class="quiz-cart-product-price">
                      <div class="quiz-cart-product-price-left">
                        <span>`;
              if (currencyPosition === "start") {
                dataCart += `${currencySymbol}${(
                  item.final_line_price / 100
                ).toFixed(2)}`;
              } else if (currencyPosition === "end") {
                dataCart += `${(item.final_line_price / 100).toFixed(
                  2
                )}${currencySymbol}`;
              }
              dataCart += `</span>
                      </div>
                    </div>`;
            }
            dataCart += `<div class="quiz-cart-product-variant">`;
            Object.entries(item.properties).forEach(([key, value]) => {
              if (key === "Select Finish") {
                dataCart += `<div class="quiz-product-variant">
                                                  <span>Finish:</span>
                                                  <div class="quiz-product-selected">
                                                    ${value}
                                                  </div>
                                                </div>`;
              }
              if (key === "Select Size") {
                dataCart += `<div class="quiz-product-variant">
                                                  <span>Size:</span>
                                                  <div class="quiz-product-selected">
                                                    ${value}
                                                  </div>
                                                </div>`;
              }
              if (key === "Select Bracelet Finish") {
                if (value !== null) {
                  dataCart += `<div class="quiz-product-variant">
                                                    <span>Bracelet Finish:</span>
                                                    <div class="quiz-product-selected">
                                                      ${value}
                                                    </div>
                                                  </div>`;
                }
              }
              if (key === "Select Bracelet Size") {
                if (value !== null) {
                  dataCart += `<div class="quiz-product-variant">
                                                <span>Bracelet Size:</span>
                                                <div class="quiz-product-selected">
                                                  ${value}
                                                </div>
                                              </div>`;
                }
              }
            });
            dataCart += `</div></div>`;
          });
          dataCart += ` </div>`;

          // ---- main div
          dataCart += `</div>`;
        });

        dataCart += `</div>`;
        // Bundle products section

        // Output the dataCart
        // ---------- bundle product code

        const totalPrice = (cart.total_price / 100).toFixed(2);
        dataCart += `</div>
        <div class="cart_total">
            <div class="quiz-subtotal quiz-carttotal">`;
        if (currencyPosition === "start") {
          dataCart += `
              <span>Cart total : ${currencySymbol}</span>
              <span class="cart-total" data-cart-total="${totalPrice}">${totalPrice}</span>`;
        } else if (currencyPosition === "end") {
          dataCart += `<span class="cart-total" data-cart-total="${totalPrice}">${totalPrice}</span>
              <span>Cart total :  ${currencySymbol}</span>`;
        }
        dataCart += `</div>
            <div class="total-purchase-price">
              <div class="quiz-subtotal">`;
        // const GetText = document.querySelector(".quiz-cart-products-added");
        // if (GetText.hasAttribute("data-text")) {
        //   const textValue = GetText.getAttribute("data-text");
        //   dataCart += `<div class="cart_total_msg">${textValue}</div>`;
        // }

        dataCart += `<span>Final Total : </span>`;
        if (currencyPosition === "start") {
          dataCart += `<span style="display: inline-block;">
                       <span> ${currencySymbol}</span>
                       <span class="total-price-pay"></span>
                      </span>`;
        } else if (currencyPosition === "end") {
          dataCart += `
                       <span class="total-price-pay"></span>
                       <span> ${currencySymbol}</span>`;
        }
        dataCart += ` 
              </div>
            </div>
          </div>`;
        cartItemsContainer.innerHTML = dataCart;
      }
    })
    .catch((error) => {
      console.error("Error fetching cart data:", error);
    });
}
cartData();

// for cart products
const intervalDataPlanets = setInterval(showMorePlanets, 1000);
function showMorePlanets() {
  // console.log('showMore---cart');
  var listLi = $(".cart-planets");
  if (listLi.length > 0) {
    setTimeout(function () {
      clearInterval(intervalDataPlanets);
    }, 3000);
  }

  $(".cart-planets").each(function () {
    var list = $(this).find("li");
    var numToShow = 4;
    // console.log()
    var buttonNext = $(this).next(".next-planets");
    // console.log(buttonNext,"buttonNext--");

    var numInList = list.length;
    // console.log(numInList,"numInList--");

    list.hide();
    if (numInList > numToShow) {
      buttonNext.show();
    }

    list.slice(0, numToShow).show();

    buttonNext.click(function (e) {
      e.preventDefault();
      // console.log('click-')

      var showing = list.filter(":visible").length;
      // console.log(showing,"showing--")
      list.slice(showing, showing + 10).fadeIn();

      var nowShowing = list.filter(":visible").length;
      // console.log(nowShowing,"nowShowing--")

      if (nowShowing >= numInList) {
        buttonNext.hide();
      }
    });
  });
}

// remove item from last page of cart
  function removeItems(itemIndices, button) {
    let updates = {};
    itemIndices.forEach((item) => {
      updates[item] = 0;
    });

    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates }),
    })
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        // console.log("Item removed successfully-------------------------");

        let cartMain = button.closest(".quiz-option-products");
        // console.log('cartMain',cartMain);
        let cartItem = button.closest(".quiz-cart-product");
        // console.log('cartItem',cartItem,cartItem.length);
        let cartNum = cartMain.find(".quiz-cart-product");
        // console.log('cartNum',cartNum,cartNum.length);

        if (itemIndices.length > 1) {
          cartMain.remove();
        } else {
          if (cartNum.length == 1) {
            cartMain.remove();
          } else {
            cartItem.remove();
          }
        }

        let removeAll = document.querySelectorAll(
          ".cart-product-list .quiz-option-products"
        );
        // console.log("removeAll", removeAll.length);

        if (removeAll.length == 0) {
          // console.log("cart --------------- empty");
          let cartData = document.querySelector(".quiz-cart-products-added");
          cartData.style.display = "none";
        }
        setTimeout(function () {
          cartData();
        }, 1000);

        setTimeout(function () {
          let QuizTotal = 0;
          let subTotal = parseFloat(
            document.querySelector(".quiz-total").innerHTML
          );
          // console.log(subTotal,"subTotal---");

          let cartTotal = parseFloat(
            document.querySelector(".cart-total").innerHTML
          );

          // alert('done---')
          // ---------------------------
          let braceletAdded = document.querySelectorAll(".bracelet-remove");
          let braceletCart = document.querySelectorAll(".cart-custom-remove");

          braceletAdded.forEach((braceletButton) => {
            braceletCart.forEach((cartButton) => {
              if (braceletButton.dataset.key === cartButton.dataset.key) {
                // Perform the desired action if the data-id matches
                let PriceBracelet = parseFloat(cartButton.dataset.price);
                // console.log(PriceBracelet, "PriceBracelet");

                cartTotal = cartTotal - PriceBracelet;

                document.querySelector(
                  ".cart-total"
                ).innerHTML = `${cartTotal}`;
                // alert("PriceBracelet-----updated");
              }
            });
          });
          // ---------------------------
          // console.log(cartTotal, "cartTotal---");
          QuizTotal += subTotal + cartTotal;

          let QuizTotalDiv = document.querySelector(".total-price-pay");
          QuizTotalDiv.innerHTML = QuizTotal.toFixed(2);
          QuizTotalDiv.setAttribute("data-total-price", QuizTotal.toFixed(2));
          // alert('done---total')
        }, 2000);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
jQuery(document).ready(function ($) {

  $(document).on("click", ".cart-custom-remove", function () {
    // $('.cart-custom-remove').on('click', function(event) {
    event.preventDefault();

    let button = $(this);
    let itemKey = button.data("key");
    // console.log(itemKey, "itemKey---", typeof itemKey);

    let itemPrice = parseFloat(button.data("price"));
    // console.log(itemPrice,"itemPrice---",typeof itemPrice);

    let itemIndex = parseFloat(button.data("index")) + 1;
    // console.log(itemIndex, "itemIndex---", typeof itemIndex);

    let mainParent = $(this).closest(".pre-checkout-page");
    // console.log(mainParent, "mainParent---");

    // setTimeout(function () {
      let finalDiv = parseFloat(
        mainParent.find(".total-price-pay").attr("data-total-price")
      );
      // console.log(finalDiv, "finalDiv", typeof finalDiv);

      let FinalTotal = finalDiv - itemPrice;
      // console.log(FinalTotal,"FinalTotal",typeof FinalTotal);

      // $(".total-price-pay").html(FinalTotal.toFixed(2));
      // $(".total-price-pay").attr("data-total-price", FinalTotal.toFixed(2));
    // }, 1000);

    // remove item using index number
    const itemIndices = [];

    if (button.hasClass("main-product")) {
      let cartMain = button.closest(".quiz-option-products");
      // console.log("cartMain", cartMain);

      let dataId = cartMain.find(".cart-custom-remove");

      dataId.each(function () {
        let dataKey = $(this).attr("data-key");
        // console.log("dataKey", dataKey, typeof dataKey);

        itemIndices.push(dataKey);
      });
    } else {
      itemIndices.push(itemKey);
    }

    // console.log("itemIndices", itemIndices, typeof itemIndices);
    removeItems(itemIndices, button);
    // remove item using index number
  });
  
  // -------------set price of bundle
  let BundleSingleSet = localStorage.getItem("BundleSingle");
  // console.log(BundleSingleSet,"BundleSingleSet");
  let BundleSingle = $(".bundleOne").html(BundleSingleSet);

  let BundleSoulmateSet = localStorage.getItem("BundleSoulmate");
  // console.log(BundleSoulmateSet,"BundleSoulmateSet");
  let BundleSoulmate = $(".bundleSec").html(BundleSoulmateSet);

  let BundlefamilySet = localStorage.getItem("Bundlefamily");
  // console.log(BundlefamilySet,"BundlefamilySet");
  let Bundlefamily = $(".bundleThird").html(BundlefamilySet);
});
